var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg500(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 339.055,
    height: 298.13,
    viewBox: "0 0 339.055 298.13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_503_Error_Service_Unavailable-amico",
    "data-name": "503 Error Service Unavailable-amico",
    transform: "translate(-11.19 -45.951)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-17",
    transform: "translate(11.19 158.02)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--floor--inject-17-2",
    "data-name": "freepik--floor--inject-17",
    cx: 169.528,
    cy: 93.03,
    rx: 169.528,
    ry: 93.03,
    fill: "#efefef"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-17",
    transform: "translate(24.937 171.155)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_2",
    "data-name": "Union 2",
    d: "M813.6,2854.528c-5.138-3.2-8.481-7.085-10.027-11.184q-1.653.562-3.34,1.1a6.67,6.67,0,0,1-4.259-.312c-15.163-7.375-40.691-18.436-51.439-27.963a2.194,2.194,0,0,1-.142-3.166q14.39-14.822,41.266-22.716a11.507,11.507,0,0,1,4.487-.241c19.976,3.621,47.47,12.075,62.313,22.524a1.747,1.747,0,0,1,.171,2.84l-.413.363a45.267,45.267,0,0,1,14.625,5.642c14.7,9.144,14.7,23.973,0,33.116-7.351,4.572-16.986,6.857-26.621,6.857S820.946,2859.1,813.6,2854.528Z",
    transform: "translate(-743.781 -2725.893)",
    fill: "#b4b6b8",
    opacity: 0.355
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-17",
    d: "M293.43,348.759l74.538-43.083a1.372,1.372,0,0,0,0-2.6L229.541,222.861a4.969,4.969,0,0,0-4.494,0l-74.538,43.083a1.372,1.372,0,0,0,0,2.6l138.428,80.217a4.969,4.969,0,0,0,4.494,0Z",
    transform: "translate(-65.085 -222.324)",
    fill: "#b4b6b8",
    opacity: 0.149
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-17-2",
    "data-name": "freepik--shadow--inject-17",
    d: "M443.421,379.3c8.313-5.175,8.313-13.552,0-18.727s-21.786-5.168-30.1,0-8.313,13.552,0,18.727S435.108,384.47,443.421,379.3Z",
    transform: "translate(-139.792 -261.307)",
    fill: "#e6e6e6",
    opacity: 0.32
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Desk--inject-17",
    transform: "translate(115.728 45.951)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--desk--inject-17-2",
    "data-name": "freepik--desk--inject-17"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Table--inject-17",
    transform: "translate(0 49.131)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_104",
    "data-name": "Path 104",
    d: "M231.849,144.909V142.24h0V121.873l-2.35-1.313V143.6L165.07,180.858v2.719l64.429-37.3V198.03l2.35,1.313V144.909Z",
    transform: "translate(-160.371 -116.727)",
    fill: "#1999cf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_105",
    "data-name": "Path 105",
    d: "M231.849,144.909V142.24h0V121.873l-2.35-1.313V143.6L165.07,180.858v2.719l64.429-37.3V198.03l2.35,1.313V144.909Z",
    transform: "translate(-160.371 -116.727)",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_106",
    "data-name": "Path 106",
    d: "M161.76,158.115v2.669h0v77.491l2.357-1.42V185.091l66.772-38.667v51.822l2.357-1.313V116.8ZM230.889,143.8l-66.772,38.667V164.348l66.772-38.454Z",
    transform: "translate(-159.41 -115.636)",
    fill: "#1999cf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_107",
    "data-name": "Path 107",
    d: "M161.76,158.115v2.669h0v77.491l2.357-1.42V185.091l66.772-38.667v51.822l2.357-1.313V116.8ZM230.889,143.8l-66.772,38.667V164.348l66.772-38.454Z",
    transform: "translate(-159.41 -115.636)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_108",
    "data-name": "Path 108",
    d: "M417.629,252.4V249.73h0V229.356l-2.357-1.306v23.043L350.85,288.348v2.719l64.422-37.3V305.52l2.357,1.306V252.4Z",
    transform: "translate(-214.268 -147.911)",
    fill: "#1999cf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_109",
    "data-name": "Path 109",
    d: "M417.629,252.4V249.73h0V229.356l-2.357-1.306v23.043L350.85,288.348v2.719l64.422-37.3V305.52l2.357,1.306V252.4Z",
    transform: "translate(-214.268 -147.911)",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_110",
    "data-name": "Path 110",
    d: "M160.8,174.743v-.192l-.17.092-2.179-1.264v79.954l2.35,1.356V182.829l129.526,74.559V329.64l2.35,1.356V250.843Z",
    transform: "translate(-158.45 -132.05)",
    fill: "#1999cf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_111",
    "data-name": "Path 111",
    d: "M160.8,174.743v-.192l-.17.092-2.179-1.264v79.954l2.35,1.356V182.829l129.526,74.559V329.64l2.35,1.356V250.843Z",
    transform: "translate(-158.45 -132.05)",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_112",
    "data-name": "Path 112",
    d: "M347.53,265.627v80.139l2.357-1.42V292.6l66.779-38.66v51.822l2.35-1.306V224.29Zm2.357,24.342v-18.13l66.779-38.462v17.932Z",
    transform: "translate(-213.305 -146.82)",
    fill: "#1999cf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_113",
    "data-name": "Path 113",
    d: "M347.53,265.627v80.139l2.357-1.42V292.6l66.779-38.66v51.822l2.35-1.306V224.29Zm2.357,24.342v-18.13l66.779-38.462v17.932Z",
    transform: "translate(-213.305 -146.82)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_114",
    "data-name": "Path 114",
    d: "M292.675,233.966l71.486-41.337L229.928,115.16,158.45,156.49Z",
    transform: "translate(-158.45 -115.16)",
    fill: "#1999cf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_115",
    "data-name": "Path 115",
    d: "M292.675,233.966l71.486-41.337L229.928,115.16,158.45,156.49Z",
    transform: "translate(-158.45 -115.16)",
    opacity: 0.1
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Phone--inject-17",
    transform: "translate(16.856 60.051)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--shadow--inject-17-3",
    "data-name": "freepik--shadow--inject-17",
    transform: "translate(1.054 7.93)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_116",
    "data-name": "Path 116",
    d: "M205.949,157.847l27.842-15.88a2.371,2.371,0,0,1,2.13,0l28.04,16.185a.653.653,0,0,1,0,1.228l-27.735,16.043a2.336,2.336,0,0,1-2.13,0L205.927,159.1a.646.646,0,0,1,.021-1.249Z",
    transform: "translate(-189.998 -141.714)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117",
    "data-name": "Path 117",
    d: "M184.617,176.6l20.26,11.7a5,5,0,0,0,4.536,0l5.289-3.067a1.384,1.384,0,0,0,0-2.619l-20.267-11.7a4.969,4.969,0,0,0-4.529,0l-5.289,3.067A1.384,1.384,0,0,0,184.617,176.6Z",
    transform: "translate(-183.68 -150.028)",
    opacity: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Cable--inject-17"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_118",
    "data-name": "Path 118",
    d: "M224.714,134.729a2.722,2.722,0,0,0-1.881-2.009c-.085-.043-.192-.035-.256-.071s-.064-.085-.106-.128a4.259,4.259,0,0,0-2.421-1.115h-.6a5.4,5.4,0,0,0-3.159-.859,3.109,3.109,0,0,0-1.249.39,1.335,1.335,0,0,0-.17-.1,3.074,3.074,0,0,0-3.109.284,2.129,2.129,0,0,0-.5-.185,2.889,2.889,0,0,0-1.42.2,4.48,4.48,0,0,0-1.235.71,3.969,3.969,0,0,0-.589.71,1.605,1.605,0,0,0-.319,0,3.344,3.344,0,0,0-2.186,1.42c-.057.071-.085.149-.142.22a3.088,3.088,0,0,0-2.009.71,3.3,3.3,0,0,0-.987,1.7h0a3.244,3.244,0,0,0-1.69,2.222,3.55,3.55,0,0,0,.092,1.42,3.18,3.18,0,0,0-1.42,1.917,1.853,1.853,0,0,0,.149,1.107,4.621,4.621,0,0,0-.816.561,2.563,2.563,0,0,0-.5.71,4,4,0,0,0-1,.177,2.841,2.841,0,0,0-.419.2,3.592,3.592,0,0,0-2.726,0c-.135.043-.234.114-.355.163a3.684,3.684,0,0,0-2.612-.057,3.968,3.968,0,0,0-2.336-.525,3.67,3.67,0,0,0-1.313.483,3.28,3.28,0,0,0-1.611-.142,3.415,3.415,0,0,0-2.009,1.555,2.924,2.924,0,0,0-.163.412,2.278,2.278,0,0,0-.8.511,2.783,2.783,0,0,0-.639,1.555,2.946,2.946,0,0,0,0,.5,2.485,2.485,0,0,0,.305,1.072h0a2.407,2.407,0,0,0,.525,2.676,2.676,2.676,0,0,0,.582.4,1.275,1.275,0,0,0,0,.17,1.7,1.7,0,0,0,.653,1.249,2.044,2.044,0,0,0,1.846.3c.22-.064,0-.312-.142-.334a6.556,6.556,0,0,1-.667-.1,1.7,1.7,0,0,1-.539-.284,1.185,1.185,0,0,1-.419-.71h0a4.821,4.821,0,0,0,.923.135,2.037,2.037,0,0,0,1.64-.476.646.646,0,0,0,0-.866,1.356,1.356,0,0,0-1.044-.44,2.428,2.428,0,0,0-2.073.859,1.318,1.318,0,0,1-.135-.078,1.867,1.867,0,0,1-.71-1.874.107.107,0,0,1,0-.05,2.747,2.747,0,0,0,2.179.71.831.831,0,0,0,.774-.866,1.242,1.242,0,0,0-.8-1.036,2.392,2.392,0,0,0-1.647-.092,3.1,3.1,0,0,0-.554.277,1.526,1.526,0,0,1-.121-.561,3.655,3.655,0,0,1,.064-.788.773.773,0,0,1,.05-.213,2.13,2.13,0,0,1,.71-.994,2.016,2.016,0,0,0,.767,1.313,1.42,1.42,0,0,0,1.938-.163.98.98,0,0,0-.106-1.143,2.13,2.13,0,0,0-1.122-.71,3.173,3.173,0,0,0-.774-.107,2.953,2.953,0,0,1,1.136-1.171,2.421,2.421,0,0,1,1.5-.177,3.017,3.017,0,0,0-.625.965,1.242,1.242,0,0,0,.149,1.193,1.1,1.1,0,0,0,1.2.376,1.377,1.377,0,0,0,.866-.923,1.42,1.42,0,0,0-.177-1.249,1.93,1.93,0,0,0-.433-.433,2.683,2.683,0,0,1,.625-.256,3.1,3.1,0,0,1,1.988.27c-.632.5-1.335,1.079-1.2,1.952s1.093.98,1.8.561a1.59,1.59,0,0,0,.71-1.122,1.647,1.647,0,0,0-.362-1.264h0a3.1,3.1,0,0,1,1.725,0,3.55,3.55,0,0,0-.5.476,1.7,1.7,0,0,0-.469,1.3,1.086,1.086,0,0,0,.944.887,1.157,1.157,0,0,0,1.157-.49,1.682,1.682,0,0,0-.192-2.13,3.968,3.968,0,0,1,.433-.185,2.84,2.84,0,0,1,1.768,0,2.13,2.13,0,0,0-.561,1.235,1.533,1.533,0,0,0,.419,1.2.8.8,0,0,0,1.044.163c.923-.71.589-1.6.05-2.449a.575.575,0,0,0-.085-.1,2.655,2.655,0,0,1,.646-.213h.213a1.839,1.839,0,0,0,.284.987,2.009,2.009,0,0,0,1.093.816.9.9,0,0,0,1.136-.376c.412-.788-.341-1.271-.951-1.6a3.8,3.8,0,0,0-.809-.284,2.619,2.619,0,0,1,.788-.767l.2-.106a3.933,3.933,0,0,0,1.058.71,2.478,2.478,0,0,0,1.7.128c.4-.121.745-.412.582-.852-.327-.88-1.193-.937-2.03-.894a5.362,5.362,0,0,0-1.058.206,1.768,1.768,0,0,1,.177-1.562,2.89,2.89,0,0,1,.71-.71,3.735,3.735,0,0,0,.426.625,2.286,2.286,0,0,0,2.35.752.887.887,0,0,0,.71-.873,1.115,1.115,0,0,0-.646-.994,3.67,3.67,0,0,0-2.478-.256,3.1,3.1,0,0,1,.142-1.775,2.84,2.84,0,0,1,.752-.973.553.553,0,0,1,.106-.071c0,.085,0,.163,0,.256.3,1.022.781,1.725,1.938,1.711a1.086,1.086,0,0,0,.951-.71,1.129,1.129,0,0,0-.206-1.264,2.769,2.769,0,0,0-2-.71.825.825,0,0,1,0-.128,2.726,2.726,0,0,1,1.32-1.462,2.13,2.13,0,0,1,.781-.156,1.973,1.973,0,0,0,.241,1.817c.476.575,1.555,1.093,1.924.085s-.511-1.817-1.37-2.257a2.91,2.91,0,0,1,.71-.831,2,2,0,0,1,1.079-.412,2.9,2.9,0,0,0-.163,1.469,1.725,1.725,0,0,0,.71,1.143,1.42,1.42,0,0,0,2.073-1,1.533,1.533,0,0,0-.419-1.129,3.315,3.315,0,0,0-1.32-.887,3.784,3.784,0,0,1,1.022-.88,2.186,2.186,0,0,1,1.768-.319,3.379,3.379,0,0,0-.632,1.136,1.42,1.42,0,0,0,.348,1.42.93.93,0,0,0,1.157.22,1.335,1.335,0,0,0,.639-1.207,2.421,2.421,0,0,0-.71-1.619,2.407,2.407,0,0,1,.916-.426,2.605,2.605,0,0,1,1.533.234c-.106.114-.227.185-.334.312-.469.6-.894,1.186-.532,1.952a1.235,1.235,0,0,0,1.164.653,1.271,1.271,0,0,0,1.136-.752c.355-.845,0-1.42-.532-2.13a.128.128,0,0,1,.05,0,3.116,3.116,0,0,1,1.548-.227,4.785,4.785,0,0,1,1.619.447,2.414,2.414,0,0,0-1.285.767,1.59,1.59,0,0,0-.355,1.327.944.944,0,0,0,.93.767,1.839,1.839,0,0,0,1.981-1.647c.071-.305-.071-.5-.142-.774a6.889,6.889,0,0,1,.973.185,3.166,3.166,0,0,1,.994.518,2.13,2.13,0,0,0-1.285.568,1.42,1.42,0,0,0,.114,2.044,1.186,1.186,0,0,0,1.768-.248,2.13,2.13,0,0,0,.376-1.718,2.456,2.456,0,0,1,.426.177,2.037,2.037,0,0,1,.994,1.64,2.733,2.733,0,0,1-.788,1.952c-.2.227.078.54.284.348A2.84,2.84,0,0,0,224.714,134.729Zm-40.18,18.308a1.931,1.931,0,0,1,.916-.312,1.3,1.3,0,0,1,.816.114.156.156,0,0,1,.064.185c0,.078,0,.085-.114.142a1.143,1.143,0,0,1-.447.128,4.438,4.438,0,0,1-.618,0h-.177a3.507,3.507,0,0,1-.476-.085h-.085a.369.369,0,0,1,.121-.17Zm-.05-2.79a.824.824,0,0,1,.71.469c.106.27-.114.383-.369.376a2.336,2.336,0,0,1-1.526-.618,1.313,1.313,0,0,1,.39-.185,2.187,2.187,0,0,1,.8-.043Zm1.32-2.35a.426.426,0,0,1-.156.589.71.71,0,0,1-.646,0,1.42,1.42,0,0,1-.816-1.292h.071a1.633,1.633,0,0,1,1.548.71Zm2.243-1.661a1.114,1.114,0,0,1-.248.887.532.532,0,0,1-.781.156.71.71,0,0,1-.163-.788,2.371,2.371,0,0,1,.646-.973,1.2,1.2,0,0,1,.547.717Zm2.925.965a.894.894,0,0,1-.809.348.327.327,0,0,1-.3-.419,2.009,2.009,0,0,1,.894-1.42,1.865,1.865,0,0,1,.234-.142,1.186,1.186,0,0,1,.327.667,1.42,1.42,0,0,1-.348.958Zm2.982-.114a.71.71,0,0,1-.767.433.568.568,0,0,1-.4-.745,2.25,2.25,0,0,1,.894-1.143,1.193,1.193,0,0,1,.27,1.455Zm3.322-.135a.532.532,0,0,1-.476.476c-.263,0-.369-.234-.412-.454a1.6,1.6,0,0,1,.064-.965,1.477,1.477,0,0,1,.334-.476,1.8,1.8,0,0,1,.206.256,1.711,1.711,0,0,1,.284,1.164Zm2.186-1.583c.312.185.987.639.4.973-.277.156-.632-.085-.845-.3a1.37,1.37,0,0,1-.376-.8,1.882,1.882,0,0,1,0-.2,2.84,2.84,0,0,1,.823.319Zm2.073-2.059a1.42,1.42,0,0,1,.866.241c.142.1.291.312.092.454a1.256,1.256,0,0,1-1.115.035,3.337,3.337,0,0,1-.98-.589,4.784,4.784,0,0,1,1.136-.142Zm.554-2.953a3.471,3.471,0,0,1,.937.128c.291.085.71.206.774.5.213.6-.461.788-.909.71a2.343,2.343,0,0,1-1.363-1.2,1.91,1.91,0,0,1,.561-.142Zm1.186-3.443c.66.057,1.42.284,1.455,1.036a.71.71,0,0,1-1.1.54,1.725,1.725,0,0,1-.667-1.555,1.5,1.5,0,0,1,.312-.021Zm2.974-1.817a1.732,1.732,0,0,1,.639.987c.043.256,0,.6-.341.518a1.249,1.249,0,0,1-.93-1.327,1.874,1.874,0,0,1,.1-.49,2.377,2.377,0,0,1,.532.341Zm3.471-.838a.71.71,0,0,1-.149.816c-.213.227-.518.44-.823.248a1.659,1.659,0,0,1-.5-1.917,1.746,1.746,0,0,1,.1-.27,2.13,2.13,0,0,1,1.4,1.122Zm2.513-.8c-.071.241-.284.511-.561.355a.923.923,0,0,1-.412-1.008,2.634,2.634,0,0,1,.568-1.044,1.725,1.725,0,0,1,.4,1.7Zm3.358-.5a.98.98,0,0,1-.71.71.625.625,0,0,1-.653-.4.831.831,0,0,1,.078-.71,3.216,3.216,0,0,1,.823-1.008,2.051,2.051,0,0,1,.27.284,1.257,1.257,0,0,1,.192,1.164Zm3.734,0a1.519,1.519,0,0,1-.838.838c-.227.092-.6.128-.71-.142a1.058,1.058,0,0,1,.17-.994,1.6,1.6,0,0,1,.76-.611,2.526,2.526,0,0,1,.575-.142,1.214,1.214,0,0,1,.043,1.086Zm2.371,1.924c-.085.035-.185.121-.27.121a.468.468,0,0,1-.227,0c-.185-.106-.312-.185-.355-.4a1.143,1.143,0,0,1,.639-1.335,1.5,1.5,0,0,1,.71-.114v.149c0,.334.028,1.342-.5,1.583Z",
    transform: "translate(-182.195 -130.543)",
    fill: "#1999cf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_119",
    "data-name": "Path 119",
    d: "M188.5,161.41Z",
    transform: "translate(-184.024 -139.498)",
    fill: "#1999cf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_120",
    "data-name": "Path 120",
    d: "M188.5,161.42Z",
    transform: "translate(-184.024 -139.501)",
    fill: "#1999cf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_121",
    "data-name": "Path 121",
    d: "M188.5,161.42Z",
    transform: "translate(-184.024 -139.501)",
    fill: "#1999cf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122",
    "data-name": "Path 122",
    d: "M188.5,161.42Z",
    transform: "translate(-184.024 -139.501)",
    fill: "#1999cf"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_382",
    "data-name": "Group 382",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_123",
    "data-name": "Path 123",
    d: "M224.714,134.729a2.722,2.722,0,0,0-1.881-2.009c-.085-.043-.192-.035-.256-.071s-.064-.085-.106-.128a4.259,4.259,0,0,0-2.421-1.115h-.6a5.4,5.4,0,0,0-3.159-.859,3.109,3.109,0,0,0-1.249.39,1.335,1.335,0,0,0-.17-.1,3.074,3.074,0,0,0-3.109.284,2.129,2.129,0,0,0-.5-.185,2.889,2.889,0,0,0-1.42.2,4.48,4.48,0,0,0-1.235.71,3.969,3.969,0,0,0-.589.71,1.605,1.605,0,0,0-.319,0,3.344,3.344,0,0,0-2.186,1.42c-.057.071-.085.149-.142.22a3.088,3.088,0,0,0-2.009.71,3.3,3.3,0,0,0-.987,1.7h0a3.244,3.244,0,0,0-1.69,2.222,3.55,3.55,0,0,0,.092,1.42,3.18,3.18,0,0,0-1.42,1.917,1.853,1.853,0,0,0,.149,1.107,4.621,4.621,0,0,0-.816.561,2.563,2.563,0,0,0-.5.71,4,4,0,0,0-1,.177,2.841,2.841,0,0,0-.419.2,3.592,3.592,0,0,0-2.726,0c-.135.043-.234.114-.355.163a3.684,3.684,0,0,0-2.612-.057,3.968,3.968,0,0,0-2.336-.525,3.67,3.67,0,0,0-1.313.483,3.28,3.28,0,0,0-1.611-.142,3.415,3.415,0,0,0-2.009,1.555,2.924,2.924,0,0,0-.163.412,2.278,2.278,0,0,0-.8.511,2.783,2.783,0,0,0-.639,1.555,2.946,2.946,0,0,0,0,.5,2.485,2.485,0,0,0,.305,1.072h0a2.407,2.407,0,0,0,.525,2.676,2.676,2.676,0,0,0,.582.4,1.275,1.275,0,0,0,0,.17,1.7,1.7,0,0,0,.653,1.249,2.044,2.044,0,0,0,1.846.3c.22-.064,0-.312-.142-.334a6.556,6.556,0,0,1-.667-.1,1.7,1.7,0,0,1-.539-.284,1.185,1.185,0,0,1-.419-.71h0a4.821,4.821,0,0,0,.923.135,2.037,2.037,0,0,0,1.64-.476.646.646,0,0,0,0-.866,1.356,1.356,0,0,0-1.044-.44,2.428,2.428,0,0,0-2.073.859,1.318,1.318,0,0,1-.135-.078,1.867,1.867,0,0,1-.71-1.874.107.107,0,0,1,0-.05,2.747,2.747,0,0,0,2.179.71.831.831,0,0,0,.774-.866,1.242,1.242,0,0,0-.8-1.036,2.392,2.392,0,0,0-1.647-.092,3.1,3.1,0,0,0-.554.277,1.526,1.526,0,0,1-.121-.561,3.655,3.655,0,0,1,.064-.788.773.773,0,0,1,.05-.213,2.13,2.13,0,0,1,.71-.994,2.016,2.016,0,0,0,.767,1.313,1.42,1.42,0,0,0,1.938-.163.98.98,0,0,0-.106-1.143,2.13,2.13,0,0,0-1.122-.71,3.173,3.173,0,0,0-.774-.107,2.953,2.953,0,0,1,1.136-1.171,2.421,2.421,0,0,1,1.5-.177,3.017,3.017,0,0,0-.625.965,1.242,1.242,0,0,0,.149,1.193,1.1,1.1,0,0,0,1.2.376,1.377,1.377,0,0,0,.866-.923,1.42,1.42,0,0,0-.177-1.249,1.93,1.93,0,0,0-.433-.433,2.683,2.683,0,0,1,.625-.256,3.1,3.1,0,0,1,1.988.27c-.632.5-1.335,1.079-1.2,1.952s1.093.98,1.8.561a1.59,1.59,0,0,0,.71-1.122,1.647,1.647,0,0,0-.362-1.264h0a3.1,3.1,0,0,1,1.725,0,3.55,3.55,0,0,0-.5.476,1.7,1.7,0,0,0-.469,1.3,1.086,1.086,0,0,0,.944.887,1.157,1.157,0,0,0,1.157-.49,1.682,1.682,0,0,0-.192-2.13,3.968,3.968,0,0,1,.433-.185,2.84,2.84,0,0,1,1.768,0,2.13,2.13,0,0,0-.561,1.235,1.533,1.533,0,0,0,.419,1.2.8.8,0,0,0,1.044.163c.923-.71.589-1.6.05-2.449a.575.575,0,0,0-.085-.1,2.655,2.655,0,0,1,.646-.213h.213a1.839,1.839,0,0,0,.284.987,2.009,2.009,0,0,0,1.093.816.9.9,0,0,0,1.136-.376c.412-.788-.341-1.271-.951-1.6a3.8,3.8,0,0,0-.809-.284,2.619,2.619,0,0,1,.788-.767l.2-.106a3.933,3.933,0,0,0,1.058.71,2.478,2.478,0,0,0,1.7.128c.4-.121.745-.412.582-.852-.327-.88-1.193-.937-2.03-.894a5.362,5.362,0,0,0-1.058.206,1.768,1.768,0,0,1,.177-1.562,2.89,2.89,0,0,1,.71-.71,3.735,3.735,0,0,0,.426.625,2.286,2.286,0,0,0,2.35.752.887.887,0,0,0,.71-.873,1.115,1.115,0,0,0-.646-.994,3.67,3.67,0,0,0-2.478-.256,3.1,3.1,0,0,1,.142-1.775,2.84,2.84,0,0,1,.752-.973.553.553,0,0,1,.106-.071c0,.085,0,.163,0,.256.3,1.022.781,1.725,1.938,1.711a1.086,1.086,0,0,0,.951-.71,1.129,1.129,0,0,0-.206-1.264,2.769,2.769,0,0,0-2-.71.825.825,0,0,1,0-.128,2.726,2.726,0,0,1,1.32-1.462,2.13,2.13,0,0,1,.781-.156,1.973,1.973,0,0,0,.241,1.817c.476.575,1.555,1.093,1.924.085s-.511-1.817-1.37-2.257a2.91,2.91,0,0,1,.71-.831,2,2,0,0,1,1.079-.412,2.9,2.9,0,0,0-.163,1.469,1.725,1.725,0,0,0,.71,1.143,1.42,1.42,0,0,0,2.073-1,1.533,1.533,0,0,0-.419-1.129,3.315,3.315,0,0,0-1.32-.887,3.784,3.784,0,0,1,1.022-.88,2.186,2.186,0,0,1,1.768-.319,3.379,3.379,0,0,0-.632,1.136,1.42,1.42,0,0,0,.348,1.42.93.93,0,0,0,1.157.22,1.335,1.335,0,0,0,.639-1.207,2.421,2.421,0,0,0-.71-1.619,2.407,2.407,0,0,1,.916-.426,2.605,2.605,0,0,1,1.533.234c-.106.114-.227.185-.334.312-.469.6-.894,1.186-.532,1.952a1.235,1.235,0,0,0,1.164.653,1.271,1.271,0,0,0,1.136-.752c.355-.845,0-1.42-.532-2.13a.128.128,0,0,1,.05,0,3.116,3.116,0,0,1,1.548-.227,4.785,4.785,0,0,1,1.619.447,2.414,2.414,0,0,0-1.285.767,1.59,1.59,0,0,0-.355,1.327.944.944,0,0,0,.93.767,1.839,1.839,0,0,0,1.981-1.647c.071-.305-.071-.5-.142-.774a6.889,6.889,0,0,1,.973.185,3.166,3.166,0,0,1,.994.518,2.13,2.13,0,0,0-1.285.568,1.42,1.42,0,0,0,.114,2.044,1.186,1.186,0,0,0,1.768-.248,2.13,2.13,0,0,0,.376-1.718,2.456,2.456,0,0,1,.426.177,2.037,2.037,0,0,1,.994,1.64,2.733,2.733,0,0,1-.788,1.952c-.2.227.078.54.284.348A2.84,2.84,0,0,0,224.714,134.729Zm-40.18,18.308a1.931,1.931,0,0,1,.916-.312,1.3,1.3,0,0,1,.816.114.156.156,0,0,1,.064.185c0,.078,0,.085-.114.142a1.143,1.143,0,0,1-.447.128,4.438,4.438,0,0,1-.618,0h-.177a3.507,3.507,0,0,1-.476-.085h-.085a.369.369,0,0,1,.121-.17Zm-.05-2.79a.824.824,0,0,1,.71.469c.106.27-.114.383-.369.376a2.336,2.336,0,0,1-1.526-.618,1.313,1.313,0,0,1,.39-.185,2.187,2.187,0,0,1,.8-.043Zm1.32-2.35a.426.426,0,0,1-.156.589.71.71,0,0,1-.646,0,1.42,1.42,0,0,1-.816-1.292h.071a1.633,1.633,0,0,1,1.548.71Zm2.243-1.661a1.114,1.114,0,0,1-.248.887.532.532,0,0,1-.781.156.71.71,0,0,1-.163-.788,2.371,2.371,0,0,1,.646-.973,1.2,1.2,0,0,1,.547.717Zm2.925.965a.894.894,0,0,1-.809.348.327.327,0,0,1-.3-.419,2.009,2.009,0,0,1,.894-1.42,1.865,1.865,0,0,1,.234-.142,1.186,1.186,0,0,1,.327.667,1.42,1.42,0,0,1-.348.958Zm2.982-.114a.71.71,0,0,1-.767.433.568.568,0,0,1-.4-.745,2.25,2.25,0,0,1,.894-1.143,1.193,1.193,0,0,1,.27,1.455Zm3.322-.135a.532.532,0,0,1-.476.476c-.263,0-.369-.234-.412-.454a1.6,1.6,0,0,1,.064-.965,1.477,1.477,0,0,1,.334-.476,1.8,1.8,0,0,1,.206.256,1.711,1.711,0,0,1,.284,1.164Zm2.186-1.583c.312.185.987.639.4.973-.277.156-.632-.085-.845-.3a1.37,1.37,0,0,1-.376-.8,1.882,1.882,0,0,1,0-.2,2.84,2.84,0,0,1,.823.319Zm2.073-2.059a1.42,1.42,0,0,1,.866.241c.142.1.291.312.092.454a1.256,1.256,0,0,1-1.115.035,3.337,3.337,0,0,1-.98-.589,4.784,4.784,0,0,1,1.136-.142Zm.554-2.953a3.471,3.471,0,0,1,.937.128c.291.085.71.206.774.5.213.6-.461.788-.909.71a2.343,2.343,0,0,1-1.363-1.2,1.91,1.91,0,0,1,.561-.142Zm1.186-3.443c.66.057,1.42.284,1.455,1.036a.71.71,0,0,1-1.1.54,1.725,1.725,0,0,1-.667-1.555,1.5,1.5,0,0,1,.312-.021Zm2.974-1.817a1.732,1.732,0,0,1,.639.987c.043.256,0,.6-.341.518a1.249,1.249,0,0,1-.93-1.327,1.874,1.874,0,0,1,.1-.49,2.377,2.377,0,0,1,.532.341Zm3.471-.838a.71.71,0,0,1-.149.816c-.213.227-.518.44-.823.248a1.659,1.659,0,0,1-.5-1.917,1.746,1.746,0,0,1,.1-.27,2.13,2.13,0,0,1,1.4,1.122Zm2.513-.8c-.071.241-.284.511-.561.355a.923.923,0,0,1-.412-1.008,2.634,2.634,0,0,1,.568-1.044,1.725,1.725,0,0,1,.4,1.7Zm3.358-.5a.98.98,0,0,1-.71.71.625.625,0,0,1-.653-.4.831.831,0,0,1,.078-.71,3.216,3.216,0,0,1,.823-1.008,2.051,2.051,0,0,1,.27.284,1.257,1.257,0,0,1,.192,1.164Zm3.734,0a1.519,1.519,0,0,1-.838.838c-.227.092-.6.128-.71-.142a1.058,1.058,0,0,1,.17-.994,1.6,1.6,0,0,1,.76-.611,2.526,2.526,0,0,1,.575-.142,1.214,1.214,0,0,1,.043,1.086Zm2.371,1.924c-.085.035-.185.121-.27.121a.468.468,0,0,1-.227,0c-.185-.106-.312-.185-.355-.4a1.143,1.143,0,0,1,.639-1.335,1.5,1.5,0,0,1,.71-.114v.149c0,.334.028,1.342-.5,1.583Z",
    transform: "translate(-182.195 -130.543)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_124",
    "data-name": "Path 124",
    d: "M188.5,161.41Z",
    transform: "translate(-184.024 -139.498)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_125",
    "data-name": "Path 125",
    d: "M188.5,161.42Z",
    transform: "translate(-184.024 -139.501)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_126",
    "data-name": "Path 126",
    d: "M188.5,161.42Z",
    transform: "translate(-184.024 -139.501)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_127",
    "data-name": "Path 127",
    d: "M188.5,161.42Z",
    transform: "translate(-184.024 -139.501)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--phone--inject-17-2",
    "data-name": "freepik--phone--inject-17",
    transform: "translate(17.58 2.859)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_128",
    "data-name": "Path 128",
    d: "M206.96,150.4l27.43-15.83,9.874,5.7-27.437,15.838Z",
    transform: "translate(-206.96 -134.57)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_129",
    "data-name": "Path 129",
    d: "M216.378,159.015l-5.26-3.038a.433.433,0,0,1,0-.823l5.3-3.052a1.562,1.562,0,0,1,1.42,0l5.232,3.053a.433.433,0,0,1,0,.823l-5.26,3.038A1.562,1.562,0,0,1,216.378,159.015Z",
    transform: "translate(-208.08 -139.606)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_130",
    "data-name": "Path 130",
    d: "M216.608,153.55,211.49,156.5l5.083,2.932a1.562,1.562,0,0,0,1.42,0l5.09-2.932-5.054-2.953A1.562,1.562,0,0,0,216.608,153.55Z",
    transform: "translate(-208.274 -140.027)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_131",
    "data-name": "Path 131",
    d: "M242.728,143.792l-5.26-3.038a.433.433,0,0,1,0-.823l5.3-3.06a1.576,1.576,0,0,1,1.42,0l5.225,3.053a.433.433,0,0,1,0,.823l-5.26,3.045A1.576,1.576,0,0,1,242.728,143.792Z",
    transform: "translate(-215.724 -135.189)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_132",
    "data-name": "Path 132",
    d: "M244.345,144.216l5.083-2.939-5.047-2.946a1.576,1.576,0,0,0-1.42,0l-5.111,2.953,5.076,2.932A1.576,1.576,0,0,0,244.345,144.216Z",
    transform: "translate(-215.922 -135.612)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_133",
    "data-name": "Path 133",
    d: "M208.5,161.34v1.817a1.256,1.256,0,0,0,.618,1.079l26.173,15.121a1.264,1.264,0,0,0,1.249,0l25.087-14.489a1.235,1.235,0,0,0,.625-1.079v-1.81L236.54,176.823a1.249,1.249,0,0,1-1.242,0Z",
    transform: "translate(-207.407 -142.336)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134",
    "data-name": "Path 134",
    d: "M266.926,146.229V151.3L239.5,167.135,220.84,156.366h0L238.4,146.229l9.882-10.769Z",
    transform: "translate(-210.987 -134.828)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_135",
    "data-name": "Path 135",
    d: "M253.043,161.4l-17.563,10.137L207,155.06v1.817a1.256,1.256,0,0,0,.625,1.079l27.267,15.759a1.249,1.249,0,0,0,1.242,0l26.188-15.121a1.25,1.25,0,0,0,.625-1.079V150.63Z",
    transform: "translate(-206.972 -139.229)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_136",
    "data-name": "Path 136",
    d: "M235.4,173.293,207,156.88V158.7a1.256,1.256,0,0,0,.625,1.079l27.267,15.759a1.264,1.264,0,0,0,.5.156Z",
    transform: "translate(-206.972 -141.042)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137",
    "data-name": "Path 137",
    d: "M235.3,176.823,208.5,161.34v1.817a1.256,1.256,0,0,0,.618,1.079l26.173,15.121a1.221,1.221,0,0,0,.511.156v-2.534A1.264,1.264,0,0,1,235.3,176.823Z",
    transform: "translate(-207.407 -142.336)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138",
    "data-name": "Path 138",
    d: "M274.1,146.229l-18.635-10-9.9,10,9.882-10.769Z",
    transform: "translate(-218.161 -134.828)",
    fill: "#fff",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_139",
    "data-name": "Path 139",
    d: "M265.913,162.368l-14.553-8.4,14.922,7.993Z",
    transform: "translate(-219.841 -140.198)",
    fill: "#fff",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140",
    "data-name": "Path 140",
    d: "M238.259,150.63l-17.541,10.137-.348-.206Z",
    transform: "translate(-210.85 -139.229)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_141",
    "data-name": "Path 141",
    d: "M269.747,150.822l-13.367-7.716,3.23-3.535h0l13.332,7.7Z",
    transform: "translate(-221.297 -136.021)",
    fill: "#1999cf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_142",
    "data-name": "Path 142",
    d: "M272.643,147.6l.3-.334-13.332-7.7-3.23,3.535.4.234,2.932-3.209Z",
    transform: "translate(-221.297 -136.021)",
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_143",
    "data-name": "Path 143",
    d: "M259.709,140.131l-.1-.561-3.23,3.535.4.234Z",
    transform: "translate(-221.297 -136.021)",
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_144",
    "data-name": "Path 144",
    d: "M256.643,153.561l-4.593-2.669.781-.852,4.579,2.662a.263.263,0,0,1,.064.412l-.327.362A.419.419,0,0,1,256.643,153.561Z",
    transform: "translate(-220.041 -139.058)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_145",
    "data-name": "Path 145",
    d: "M252.8,149.609a.142.142,0,0,0-.085-.106l-.788-.454a.27.27,0,0,0-.319.057l-.71.745a.163.163,0,0,0-.05.142c0,.043.064.256.071.305a.185.185,0,0,0,.085.106l.788.454a.284.284,0,0,0,.319-.057l.71-.745a.149.149,0,0,0,.043-.149A2.5,2.5,0,0,0,252.8,149.609Z",
    transform: "translate(-219.692 -138.762)",
    fill: "#1999cf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_146",
    "data-name": "Path 146",
    d: "M252.391,150.878a.206.206,0,0,0,.128-.071l.71-.745a.149.149,0,0,0,.043-.149,2.573,2.573,0,0,0-.071-.3.142.142,0,0,0-.085-.106l-.788-.454a.248.248,0,0,0-.177,0Z",
    transform: "translate(-220.07 -138.767)",
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_147",
    "data-name": "Path 147",
    d: "M251.751,149a.234.234,0,0,0-.142.078l-.71.745a.163.163,0,0,0-.05.142c0,.043.064.256.071.305a.185.185,0,0,0,.085.106l.788.454a.255.255,0,0,0,.192,0Z",
    transform: "translate(-219.692 -138.756)",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_148",
    "data-name": "Path 148",
    d: "M252.083,150.5l.71-.745a.156.156,0,0,0-.043-.256l-.788-.454a.27.27,0,0,0-.319.057l-.71.745a.156.156,0,0,0,0,.256l.788.447A.277.277,0,0,0,252.083,150.5Z",
    transform: "translate(-219.698 -138.762)",
    fill: "#1999cf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_149",
    "data-name": "Path 149",
    d: "M259.2,150.794l-4.593-2.662.781-.852,4.579,2.662a.256.256,0,0,1,.064.412l-.327.362a.419.419,0,0,1-.5.078Z",
    transform: "translate(-220.784 -138.257)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_150",
    "data-name": "Path 150",
    d: "M255.373,146.808a.22.22,0,0,0-.085-.114l-.788-.447a.27.27,0,0,0-.319.05l-.71.752a.142.142,0,0,0-.043.142,2.68,2.68,0,0,0,.071.305.156.156,0,0,0,.085.106l.788.447a.27.27,0,0,0,.319-.05l.71-.71a.177.177,0,0,0,.05-.149C255.43,147.063,255.38,146.858,255.373,146.808Z",
    transform: "translate(-220.44 -137.949)",
    fill: "#1999cf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_151",
    "data-name": "Path 151",
    d: "M254.964,148.093a.284.284,0,0,0,.128-.071l.71-.71a.177.177,0,0,0,.05-.149c0-.043-.064-.248-.071-.3a.22.22,0,0,0-.085-.114l-.788-.447a.263.263,0,0,0-.177,0Z",
    transform: "translate(-220.819 -137.97)",
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_152",
    "data-name": "Path 152",
    d: "M254.323,146.23a.249.249,0,0,0-.142.071l-.71.752a.142.142,0,0,0-.043.142,2.681,2.681,0,0,0,.071.305.156.156,0,0,0,.085.106l.788.447a.255.255,0,0,0,.192,0Z",
    transform: "translate(-220.44 -137.953)",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_153",
    "data-name": "Path 153",
    d: "M254.65,147.7l.71-.752a.163.163,0,0,0-.043-.256l-.788-.447a.27.27,0,0,0-.319.05l-.71.752a.149.149,0,0,0,.043.248l.788.454a.284.284,0,0,0,.319-.05Z",
    transform: "translate(-220.448 -137.949)",
    fill: "#1999cf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_154",
    "data-name": "Path 154",
    d: "M267.413,159.814l-4.593-2.669.781-.845,4.579,2.655a.263.263,0,0,1,.064.412l-.327.369A.419.419,0,0,1,267.413,159.814Z",
    transform: "translate(-223.166 -140.874)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_155",
    "data-name": "Path 155",
    d: "M263.58,155.82a.206.206,0,0,0-.085-.106l-.788-.447a.277.277,0,0,0-.327.05l-.71.745a.149.149,0,0,0-.043.149c0,.043.057.256.064.3a.22.22,0,0,0,.085.114l.788.447a.277.277,0,0,0,.327-.05l.71-.745a.156.156,0,0,0,.043-.149C263.637,156.083,263.587,155.87,263.58,155.82Z",
    transform: "translate(-222.818 -140.565)",
    fill: "#1999cf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_156",
    "data-name": "Path 156",
    d: "M263.174,157.1a.284.284,0,0,0,.128-.071l.71-.745a.156.156,0,0,0,.043-.149c0-.043-.057-.256-.064-.305a.206.206,0,0,0-.085-.106l-.788-.447a.312.312,0,0,0-.177,0Z",
    transform: "translate(-223.201 -140.573)",
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_157",
    "data-name": "Path 157",
    d: "M262.529,155.24a.305.305,0,0,0-.149.078l-.71.745a.149.149,0,0,0-.043.149c0,.043.057.256.064.3a.22.22,0,0,0,.085.114l.788.447a.319.319,0,0,0,.2,0Z",
    transform: "translate(-222.818 -140.567)",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_158",
    "data-name": "Path 158",
    d: "M262.86,156.729l.71-.71a.156.156,0,0,0-.035-.256l-.788-.447a.277.277,0,0,0-.327.05l-.71.745a.156.156,0,0,0,.043.256l.788.447a.27.27,0,0,0,.319-.085Z",
    transform: "translate(-222.83 -140.58)",
    fill: "#1999cf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_159",
    "data-name": "Path 159",
    d: "M269.983,157.011l-4.593-2.669.781-.852,4.579,2.662a.263.263,0,0,1,.064.412l-.327.369a.419.419,0,0,1-.5.078Z",
    transform: "translate(-223.911 -140.059)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_160",
    "data-name": "Path 160",
    d: "M266.145,153.021a.156.156,0,0,0-.085-.106l-.788-.447a.27.27,0,0,0-.319.05l-.71.71a.185.185,0,0,0-.043.142,2.689,2.689,0,0,0,.071.305.142.142,0,0,0,.085.106l.788.454a.284.284,0,0,0,.334.021l.71-.752a.185.185,0,0,0,.043-.142C266.187,153.283,266.187,153.071,266.145,153.021Z",
    transform: "translate(-223.566 -139.753)",
    fill: "#1999cf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161",
    "data-name": "Path 161",
    d: "M265.728,154.276a.22.22,0,0,0,.121,0l.71-.752a.185.185,0,0,0,.043-.142,2.682,2.682,0,0,0-.071-.305.156.156,0,0,0-.085-.106l-.788-.447a.22.22,0,0,0-.177,0Z",
    transform: "translate(-223.938 -139.773)",
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_162",
    "data-name": "Path 162",
    d: "M265.094,152.44a.22.22,0,0,0-.142.078l-.71.71a.185.185,0,0,0-.043.142,2.675,2.675,0,0,0,.071.305.142.142,0,0,0,.085.106l.788.454a.255.255,0,0,0,.192,0Z",
    transform: "translate(-223.566 -139.754)",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_163",
    "data-name": "Path 163",
    d: "M265.422,153.915l.71-.745a.156.156,0,0,0-.043-.256l-.788-.447a.27.27,0,0,0-.319.05l-.71.71a.163.163,0,0,0,.043.256l.788.447A.27.27,0,0,0,265.422,153.915Z",
    transform: "translate(-223.574 -139.753)",
    fill: "#1999cf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_164",
    "data-name": "Path 164",
    d: "M245.223,153.512l-1.626.944a.419.419,0,0,0,0,.788l.71.412a1.5,1.5,0,0,0,1.37,0l1.633-.937a.419.419,0,0,0,0-.788l-.71-.419a1.5,1.5,0,0,0-1.377,0Z",
    transform: "translate(-217.509 -140.017)",
    fill: "#1999cf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_165",
    "data-name": "Path 165",
    d: "M247.506,155a.909.909,0,0,1-.156.121l-1.633.937a1.491,1.491,0,0,1-1.363,0l-.71-.419a.992.992,0,0,1-.156-.114.419.419,0,0,1-.128-.256v.525a.476.476,0,0,0,.284.4l.71.412a1.491,1.491,0,0,0,1.363,0l1.633-.937a.49.49,0,0,0,.277-.4v-.54a.4.4,0,0,1-.121.27Z",
    transform: "translate(-217.52 -140.419)",
    fill: "#1999cf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_166",
    "data-name": "Path 166",
    d: "M251.8,157.282l-1.633.937a.419.419,0,0,0,0,.788l.71.419a1.548,1.548,0,0,0,1.37,0l1.633-.944a.412.412,0,0,0,0-.781l-.71-.419a1.491,1.491,0,0,0-1.37,0Z",
    transform: "translate(-219.415 -141.111)",
    fill: "#1999cf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_167",
    "data-name": "Path 167",
    d: "M254.046,158.76a.71.71,0,0,1-.156.121l-1.633.944a1.533,1.533,0,0,1-1.363,0l-.71-.419a.709.709,0,0,1-.156-.121.419.419,0,0,1-.128-.256v.532a.49.49,0,0,0,.284.4l.71.412a1.512,1.512,0,0,0,1.363,0l1.633-.944a.483.483,0,0,0,.284-.39v-.547A.369.369,0,0,1,254.046,158.76Z",
    transform: "translate(-219.418 -141.51)",
    fill: "#1999cf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_168",
    "data-name": "Path 168",
    d: "M256.888,160.232l-1.626.937c-.383.22-.383.568,0,.788l.71.419a1.548,1.548,0,0,0,1.37,0l1.633-.944a.412.412,0,0,0,0-.781l-.71-.419A1.5,1.5,0,0,0,256.888,160.232Z",
    transform: "translate(-220.89 -141.967)",
    fill: "#1999cf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_169",
    "data-name": "Path 169",
    d: "M259.143,161.707a.768.768,0,0,1-.163.128l-1.626.937a1.547,1.547,0,0,1-1.37,0l-.71-.419a.71.71,0,0,1-.156-.121.419.419,0,0,1-.128-.256v.525a.476.476,0,0,0,.284.4l.71.412a1.526,1.526,0,0,0,1.37,0l1.626-.944a.469.469,0,0,0,.284-.39v-.547A.391.391,0,0,1,259.143,161.707Z",
    transform: "translate(-220.894 -142.362)",
    fill: "#1999cf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_170",
    "data-name": "Path 170",
    d: "M261.93,163.173l-1.633.937a.419.419,0,0,0,0,.788l.71.419a1.491,1.491,0,0,0,1.363,0l1.633-.937a.419.419,0,0,0,0-.788l-.71-.419A1.491,1.491,0,0,0,261.93,163.173Z",
    transform: "translate(-222.354 -142.82)",
    fill: "#1999cf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_171",
    "data-name": "Path 171",
    d: "M264.176,164.657a.568.568,0,0,1-.156.121l-1.633.937a1.491,1.491,0,0,1-1.363,0l-.71-.419a.994.994,0,0,1-.156-.114.433.433,0,0,1-.128-.263v.532a.483.483,0,0,0,.284.39l.71.419a1.491,1.491,0,0,0,1.363,0l1.633-.937a.483.483,0,0,0,.284-.4v-.547A.383.383,0,0,1,264.176,164.657Z",
    transform: "translate(-222.356 -143.218)",
    fill: "#1999cf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_172",
    "data-name": "Path 172",
    d: "M239.82,156.647l-1.633.909a.419.419,0,0,0,0,.788l.71.419a1.533,1.533,0,0,0,1.363,0l1.633-.937c.383-.22.383-.575,0-.788l-.71-.419A1.491,1.491,0,0,0,239.82,156.647Z",
    transform: "translate(-215.939 -140.923)",
    fill: "#1999cf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_173",
    "data-name": "Path 173",
    d: "M242.066,158.127a.476.476,0,0,1-.156.128l-1.633.937a1.533,1.533,0,0,1-1.363,0l-.71-.419a.97.97,0,0,1-.163-.121.4.4,0,0,1-.121-.256v.532a.469.469,0,0,0,.284.39l.71.412a1.469,1.469,0,0,0,1.363,0l1.633-.944a.468.468,0,0,0,.284-.39v-.547A.369.369,0,0,1,242.066,158.127Z",
    transform: "translate(-215.942 -141.324)",
    fill: "#1999cf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_174",
    "data-name": "Path 174",
    d: "M246.363,160.412l-1.626.944a.419.419,0,0,0,0,.788l.71.412a1.505,1.505,0,0,0,1.37,0l1.633-.937a.419.419,0,0,0,0-.788l-.71-.419a1.505,1.505,0,0,0-1.377,0Z",
    transform: "translate(-217.839 -142.019)",
    fill: "#1999cf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_175",
    "data-name": "Path 175",
    d: "M248.616,161.89a.909.909,0,0,1-.156.121l-1.633.937a1.491,1.491,0,0,1-1.363,0l-.71-.419a.994.994,0,0,1-.156-.114.419.419,0,0,1-.128-.256v.525a.468.468,0,0,0,.284.39l.71.419a1.491,1.491,0,0,0,1.363,0l1.633-.937a.49.49,0,0,0,.277-.4v-.54A.4.4,0,0,1,248.616,161.89Z",
    transform: "translate(-217.842 -142.418)",
    fill: "#1999cf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_176",
    "data-name": "Path 176",
    d: "M251.46,163.365l-1.633.944a.419.419,0,0,0,0,.788l.71.412a1.491,1.491,0,0,0,1.363,0l1.633-.937c.376-.22.383-.568,0-.788l-.71-.419a1.533,1.533,0,0,0-1.363,0Z",
    transform: "translate(-219.316 -142.877)",
    fill: "#1999cf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_177",
    "data-name": "Path 177",
    d: "M253.706,164.89a.568.568,0,0,1-.156.121l-1.633.937a1.491,1.491,0,0,1-1.363,0l-.71-.419a1.079,1.079,0,0,1-.163-.114.4.4,0,0,1-.121-.256v.525a.476.476,0,0,0,.284.4l.71.412a1.491,1.491,0,0,0,1.363,0l1.633-.937a.483.483,0,0,0,.284-.4v-.54A.383.383,0,0,1,253.706,164.89Z",
    transform: "translate(-219.319 -143.288)",
    fill: "#1999cf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_178",
    "data-name": "Path 178",
    d: "M256.5,166.31l-1.611.937a.419.419,0,0,0,0,.788l.71.419a1.548,1.548,0,0,0,1.37,0l1.633-.944a.412.412,0,0,0,0-.781l-.71-.419a1.5,1.5,0,0,0-1.391,0Z",
    transform: "translate(-220.784 -143.729)",
    fill: "#1999cf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_179",
    "data-name": "Path 179",
    d: "M258.746,167.781a.91.91,0,0,1-.156.121l-1.633.944a1.533,1.533,0,0,1-1.363,0l-.71-.419a.709.709,0,0,1-.156-.121.419.419,0,0,1-.128-.256v.511a.476.476,0,0,0,.284.4l.71.412a1.512,1.512,0,0,0,1.363,0l1.633-.944a.483.483,0,0,0,.284-.39v-.547A.4.4,0,0,1,258.746,167.781Z",
    transform: "translate(-220.781 -144.121)",
    fill: "#1999cf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_180",
    "data-name": "Path 180",
    d: "M234.39,159.785l-1.633.944a.419.419,0,0,0,0,.788l.71.412a1.491,1.491,0,0,0,1.363,0l1.633-.937a.419.419,0,0,0,0-.788l-.71-.419A1.533,1.533,0,0,0,234.39,159.785Z",
    transform: "translate(-214.364 -141.839)",
    fill: "#1999cf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_181",
    "data-name": "Path 181",
    d: "M236.636,161.27a.568.568,0,0,1-.156.121l-1.633.937a1.491,1.491,0,0,1-1.363,0l-.71-.419-.156-.114a.461.461,0,0,1-.128-.256v.525a.49.49,0,0,0,.284.4l.71.412a1.512,1.512,0,0,0,1.363,0l1.633-.944a.483.483,0,0,0,.284-.4V161a.383.383,0,0,1-.128.27Z",
    transform: "translate(-214.367 -142.238)",
    fill: "#1999cf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_182",
    "data-name": "Path 182",
    d: "M240.93,163.553l-1.633.937a.419.419,0,0,0,0,.788l.71.419a1.533,1.533,0,0,0,1.363,0l1.633-.937c.383-.22.383-.575,0-.788l-.71-.419a1.491,1.491,0,0,0-1.363,0Z",
    transform: "translate(-216.261 -142.93)",
    fill: "#1999cf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_183",
    "data-name": "Path 183",
    d: "M243.176,165.027a.582.582,0,0,1-.156.128l-1.633.937a1.533,1.533,0,0,1-1.363,0l-.71-.419a.974.974,0,0,1-.163-.121.4.4,0,0,1-.121-.256v.532a.469.469,0,0,0,.284.39l.71.412a1.512,1.512,0,0,0,1.363,0l1.633-.944a.468.468,0,0,0,.284-.39v-.547a.369.369,0,0,1-.128.277Z",
    transform: "translate(-216.264 -143.326)",
    fill: "#1999cf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_184",
    "data-name": "Path 184",
    d: "M246.03,166.5l-1.633.937a.419.419,0,0,0,0,.788l.71.419a1.533,1.533,0,0,0,1.363,0l1.633-.937a.419.419,0,0,0,0-.788l-.71-.419A1.491,1.491,0,0,0,246.03,166.5Z",
    transform: "translate(-217.741 -143.786)",
    fill: "#1999cf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_185",
    "data-name": "Path 185",
    d: "M248.306,167.977a.476.476,0,0,1-.156.128l-1.633.937a1.533,1.533,0,0,1-1.363,0l-.71-.419a.71.71,0,0,1-.156-.121.419.419,0,0,1-.128-.256v.532a.483.483,0,0,0,.284.39l.71.412a1.469,1.469,0,0,0,1.363,0l1.633-.944a.469.469,0,0,0,.284-.39V167.7A.369.369,0,0,1,248.306,167.977Z",
    transform: "translate(-217.752 -144.182)",
    fill: "#1999cf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_186",
    "data-name": "Path 186",
    d: "M251.058,169.441l-1.626.944c-.383.213-.383.568,0,.788l.71.412a1.491,1.491,0,0,0,1.363,0l1.64-.937a.419.419,0,0,0,0-.788l-.71-.419A1.491,1.491,0,0,0,251.058,169.441Z",
    transform: "translate(-219.198 -144.638)",
    fill: "#1999cf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_187",
    "data-name": "Path 187",
    d: "M253.3,170.887a.753.753,0,0,1-.163.121l-1.633.937a1.491,1.491,0,0,1-1.363,0l-.71-.419a.993.993,0,0,1-.156-.114.383.383,0,0,1-.128-.256v.525a.461.461,0,0,0,.284.39l.71.419a1.491,1.491,0,0,0,1.363,0l1.633-.937a.483.483,0,0,0,.284-.4v-.547A.4.4,0,0,1,253.3,170.887Z",
    transform: "translate(-219.2 -145.026)",
    fill: "#1999cf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_188",
    "data-name": "Path 188",
    d: "M228.96,162.932l-1.633.937a.419.419,0,0,0,0,.788l.71.419a1.505,1.505,0,0,0,1.37,0l1.633-.937a.419.419,0,0,0,0-.788l-.71-.419A1.491,1.491,0,0,0,228.96,162.932Z",
    transform: "translate(-212.788 -142.75)",
    fill: "#1999cf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_189",
    "data-name": "Path 189",
    d: "M231.206,164.407a.709.709,0,0,1-.156.121l-1.633.937a1.533,1.533,0,0,1-1.363,0l-.71-.419a.709.709,0,0,1-.156-.121.4.4,0,0,1-.128-.256v.532a.483.483,0,0,0,.284.39l.71.419a1.491,1.491,0,0,0,1.363,0l1.633-.944a.483.483,0,0,0,.284-.39v-.547a.383.383,0,0,1-.128.277Z",
    transform: "translate(-212.791 -143.146)",
    fill: "#1999cf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_190",
    "data-name": "Path 190",
    d: "M235.5,166.685l-1.633.944a.419.419,0,0,0,0,.788l.71.412a1.491,1.491,0,0,0,1.363,0l1.633-.937a.419.419,0,0,0,0-.788l-.71-.419a1.533,1.533,0,0,0-1.363,0Z",
    transform: "translate(-214.686 -143.841)",
    fill: "#1999cf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_191",
    "data-name": "Path 191",
    d: "M237.746,168.17a.568.568,0,0,1-.156.121l-1.633.937a1.491,1.491,0,0,1-1.363,0l-.71-.419-.156-.114a.461.461,0,0,1-.128-.256v.525a.49.49,0,0,0,.284.4l.71.412a1.491,1.491,0,0,0,1.363,0l1.633-.937a.483.483,0,0,0,.284-.4v-.54A.383.383,0,0,1,237.746,168.17Z",
    transform: "translate(-214.689 -144.24)",
    fill: "#1999cf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_192",
    "data-name": "Path 192",
    d: "M240.593,169.63l-1.626.923a.419.419,0,0,0,0,.788l.71.412a1.5,1.5,0,0,0,1.37,0l1.633-.937a.419.419,0,0,0,0-.788l-.71-.419A1.548,1.548,0,0,0,240.593,169.63Z",
    transform: "translate(-216.165 -144.691)",
    fill: "#1999cf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_193",
    "data-name": "Path 193",
    d: "M242.846,171.117a.709.709,0,0,1-.156.121l-1.633.937a1.491,1.491,0,0,1-1.363,0l-.71-.412a.994.994,0,0,1-.156-.121.419.419,0,0,1-.128-.256v.525a.476.476,0,0,0,.284.4l.71.412a1.512,1.512,0,0,0,1.363,0l1.633-.944a.5.5,0,0,0,.284-.4v-.54a.383.383,0,0,1-.128.277Z",
    transform: "translate(-216.168 -145.092)",
    fill: "#1999cf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_194",
    "data-name": "Path 194",
    d: "M245.63,172.583,244,173.52a.419.419,0,0,0,0,.788l.71.419a1.533,1.533,0,0,0,1.363,0l1.633-.937c.376-.22.383-.575,0-.788l-.71-.419A1.491,1.491,0,0,0,245.63,172.583Z",
    transform: "translate(-217.625 -145.55)",
    fill: "#1999cf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_195",
    "data-name": "Path 195",
    d: "M247.876,174.057a.582.582,0,0,1-.156.128l-1.633.937a1.533,1.533,0,0,1-1.363,0l-.71-.419a.752.752,0,0,1-.163-.121.4.4,0,0,1-.121-.256v.532a.469.469,0,0,0,.284.39l.71.412a1.512,1.512,0,0,0,1.363,0l1.633-.944a.468.468,0,0,0,.284-.39v-.547A.369.369,0,0,1,247.876,174.057Z",
    transform: "translate(-217.628 -145.945)",
    fill: "#1999cf"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_383",
    "data-name": "Group 383",
    transform: "translate(14.269 14.311)",
    opacity: 0.35
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_196",
    "data-name": "Path 196",
    d: "M247.506,155a.909.909,0,0,1-.156.121l-1.633.937a1.491,1.491,0,0,1-1.363,0l-.71-.419a.992.992,0,0,1-.156-.114.419.419,0,0,1-.128-.256v.525a.476.476,0,0,0,.284.4l.71.412a1.491,1.491,0,0,0,1.363,0l1.633-.937a.49.49,0,0,0,.277-.4v-.54a.4.4,0,0,1-.121.27Z",
    transform: "translate(-231.789 -154.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_197",
    "data-name": "Path 197",
    d: "M254.046,158.76a.71.71,0,0,1-.156.121l-1.633.944a1.533,1.533,0,0,1-1.363,0l-.71-.419a.709.709,0,0,1-.156-.121.419.419,0,0,1-.128-.256v.532a.49.49,0,0,0,.284.4l.71.412a1.512,1.512,0,0,0,1.363,0l1.633-.944a.483.483,0,0,0,.284-.39v-.547A.369.369,0,0,1,254.046,158.76Z",
    transform: "translate(-233.686 -155.821)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_198",
    "data-name": "Path 198",
    d: "M259.143,161.707a.768.768,0,0,1-.163.128l-1.626.937a1.547,1.547,0,0,1-1.37,0l-.71-.419a.71.71,0,0,1-.156-.121.419.419,0,0,1-.128-.256v.525a.476.476,0,0,0,.284.4l.71.412a1.526,1.526,0,0,0,1.37,0l1.626-.944a.469.469,0,0,0,.284-.39v-.547A.391.391,0,0,1,259.143,161.707Z",
    transform: "translate(-235.163 -156.674)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_199",
    "data-name": "Path 199",
    d: "M264.176,164.657a.568.568,0,0,1-.156.121l-1.633.937a1.491,1.491,0,0,1-1.363,0l-.71-.419a.994.994,0,0,1-.156-.114.433.433,0,0,1-.128-.263v.532a.483.483,0,0,0,.284.39l.71.419a1.491,1.491,0,0,0,1.363,0l1.633-.937a.483.483,0,0,0,.284-.4v-.547A.383.383,0,0,1,264.176,164.657Z",
    transform: "translate(-236.625 -157.53)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_200",
    "data-name": "Path 200",
    d: "M242.066,158.127a.476.476,0,0,1-.156.128l-1.633.937a1.533,1.533,0,0,1-1.363,0l-.71-.419a.97.97,0,0,1-.163-.121.4.4,0,0,1-.121-.256v.532a.469.469,0,0,0,.284.39l.71.412a1.469,1.469,0,0,0,1.363,0l1.633-.944a.468.468,0,0,0,.284-.39v-.547A.369.369,0,0,1,242.066,158.127Z",
    transform: "translate(-230.211 -155.635)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_201",
    "data-name": "Path 201",
    d: "M248.616,161.89a.909.909,0,0,1-.156.121l-1.633.937a1.491,1.491,0,0,1-1.363,0l-.71-.419a.994.994,0,0,1-.156-.114.419.419,0,0,1-.128-.256v.525a.468.468,0,0,0,.284.39l.71.419a1.491,1.491,0,0,0,1.363,0l1.633-.937a.49.49,0,0,0,.277-.4v-.54A.4.4,0,0,1,248.616,161.89Z",
    transform: "translate(-232.111 -156.729)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_202",
    "data-name": "Path 202",
    d: "M253.706,164.89a.568.568,0,0,1-.156.121l-1.633.937a1.491,1.491,0,0,1-1.363,0l-.71-.419a1.079,1.079,0,0,1-.163-.114.4.4,0,0,1-.121-.256v.525a.476.476,0,0,0,.284.4l.71.412a1.491,1.491,0,0,0,1.363,0l1.633-.937a.483.483,0,0,0,.284-.4v-.54A.383.383,0,0,1,253.706,164.89Z",
    transform: "translate(-233.588 -157.599)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_203",
    "data-name": "Path 203",
    d: "M258.746,167.781a.91.91,0,0,1-.156.121l-1.633.944a1.533,1.533,0,0,1-1.363,0l-.71-.419a.709.709,0,0,1-.156-.121.419.419,0,0,1-.128-.256v.511a.476.476,0,0,0,.284.4l.71.412a1.512,1.512,0,0,0,1.363,0l1.633-.944a.483.483,0,0,0,.284-.39v-.547A.4.4,0,0,1,258.746,167.781Z",
    transform: "translate(-235.05 -158.432)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_204",
    "data-name": "Path 204",
    d: "M236.636,161.27a.568.568,0,0,1-.156.121l-1.633.937a1.491,1.491,0,0,1-1.363,0l-.71-.419-.156-.114a.461.461,0,0,1-.128-.256v.525a.49.49,0,0,0,.284.4l.71.412a1.512,1.512,0,0,0,1.363,0l1.633-.944a.483.483,0,0,0,.284-.4V161a.383.383,0,0,1-.128.27Z",
    transform: "translate(-228.635 -156.549)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_205",
    "data-name": "Path 205",
    d: "M243.176,165.027a.582.582,0,0,1-.156.128l-1.633.937a1.533,1.533,0,0,1-1.363,0l-.71-.419a.974.974,0,0,1-.163-.121.4.4,0,0,1-.121-.256v.532a.469.469,0,0,0,.284.39l.71.412a1.512,1.512,0,0,0,1.363,0l1.633-.944a.468.468,0,0,0,.284-.39v-.547a.369.369,0,0,1-.128.277Z",
    transform: "translate(-230.533 -157.637)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_206",
    "data-name": "Path 206",
    d: "M248.306,167.977a.476.476,0,0,1-.156.128l-1.633.937a1.533,1.533,0,0,1-1.363,0l-.71-.419a.71.71,0,0,1-.156-.121.419.419,0,0,1-.128-.256v.532a.483.483,0,0,0,.284.39l.71.412a1.469,1.469,0,0,0,1.363,0l1.633-.944a.469.469,0,0,0,.284-.39V167.7A.369.369,0,0,1,248.306,167.977Z",
    transform: "translate(-232.021 -158.493)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_207",
    "data-name": "Path 207",
    d: "M253.3,170.887a.753.753,0,0,1-.163.121l-1.633.937a1.491,1.491,0,0,1-1.363,0l-.71-.419a.993.993,0,0,1-.156-.114.383.383,0,0,1-.128-.256v.525a.461.461,0,0,0,.284.39l.71.419a1.491,1.491,0,0,0,1.363,0l1.633-.937a.483.483,0,0,0,.284-.4v-.547A.4.4,0,0,1,253.3,170.887Z",
    transform: "translate(-233.469 -159.337)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_208",
    "data-name": "Path 208",
    d: "M231.206,164.407a.709.709,0,0,1-.156.121l-1.633.937a1.533,1.533,0,0,1-1.363,0l-.71-.419a.709.709,0,0,1-.156-.121.4.4,0,0,1-.128-.256v.532a.483.483,0,0,0,.284.39l.71.419a1.491,1.491,0,0,0,1.363,0l1.633-.944a.483.483,0,0,0,.284-.39v-.547a.383.383,0,0,1-.128.277Z",
    transform: "translate(-227.06 -157.457)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_209",
    "data-name": "Path 209",
    d: "M237.746,168.17a.568.568,0,0,1-.156.121l-1.633.937a1.491,1.491,0,0,1-1.363,0l-.71-.419-.156-.114a.461.461,0,0,1-.128-.256v.525a.49.49,0,0,0,.284.4l.71.412a1.491,1.491,0,0,0,1.363,0l1.633-.937a.483.483,0,0,0,.284-.4v-.54A.383.383,0,0,1,237.746,168.17Z",
    transform: "translate(-228.957 -158.551)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_210",
    "data-name": "Path 210",
    d: "M242.846,171.117a.709.709,0,0,1-.156.121l-1.633.937a1.491,1.491,0,0,1-1.363,0l-.71-.412a.994.994,0,0,1-.156-.121.419.419,0,0,1-.128-.256v.525a.476.476,0,0,0,.284.4l.71.412a1.512,1.512,0,0,0,1.363,0l1.633-.944a.5.5,0,0,0,.284-.4v-.54a.383.383,0,0,1-.128.277Z",
    transform: "translate(-230.437 -159.404)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_211",
    "data-name": "Path 211",
    d: "M247.876,174.057a.582.582,0,0,1-.156.128l-1.633.937a1.533,1.533,0,0,1-1.363,0l-.71-.419a.752.752,0,0,1-.163-.121.4.4,0,0,1-.121-.256v.532a.469.469,0,0,0,.284.39l.71.412a1.512,1.512,0,0,0,1.363,0l1.633-.944a.468.468,0,0,0,.284-.39v-.547A.369.369,0,0,1,247.876,174.057Z",
    transform: "translate(-231.896 -160.257)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_212",
    "data-name": "Path 212",
    d: "M259.236,143.761a.156.156,0,0,1,.043-.085l1.306-1.583a.149.149,0,0,1,.085-.057.121.121,0,0,1,.092,0l.816.461s.043.035,0,.064,0,.05-.05.092l-.057.064a.248.248,0,0,1-.085.071.078.078,0,0,1-.078,0l-.54-.305-.362.44.483.277s.035,0,0,.057a.163.163,0,0,1-.05.092l-.05.064a.311.311,0,0,1-.085.071.064.064,0,0,1-.078,0l-.483-.27-.4.483.539.305a.057.057,0,0,1,.035.057.227.227,0,0,1-.057.092l-.05.064a.383.383,0,0,1-.085.078.1.1,0,0,1-.078,0l-.823-.469a.113.113,0,0,1,.007-.064Z",
    transform: "translate(-222.124 -136.733)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_213",
    "data-name": "Path 213",
    d: "M261.061,144.728l1.327-1.6a.121.121,0,0,1,.085-.057.149.149,0,0,1,.092,0l.454.263c.376.213.433.476.17.8a.71.71,0,0,1-.625.27h0a.476.476,0,0,1-.035.383l-.234.582h0c0,.036-.1,0-.2,0l-.085-.05c-.085-.05-.121-.092-.092-.142l.248-.568a.376.376,0,0,0,0-.163.227.227,0,0,0-.107-.114l-.106-.057-.518.625c-.043.05-.106.043-.206,0l-.078-.043C261.047,144.828,261.011,144.778,261.061,144.728Zm1.342-.611a.206.206,0,0,0,.185,0,.455.455,0,0,0,.206-.149.319.319,0,0,0,.092-.213.149.149,0,0,0-.092-.135l-.192-.106-.4.483Z",
    transform: "translate(-222.649 -137.033)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_214",
    "data-name": "Path 214",
    d: "M263.088,145.884l1.349-1.611a.149.149,0,0,1,.078-.057.114.114,0,0,1,.092,0l.454.256c.376.213.433.483.17.8a.71.71,0,0,1-.618.277h0a.461.461,0,0,1,0,.39l-.234.582h0c0,.043-.1,0-.2,0l-.078-.043c-.092-.05-.121-.1-.1-.142l.248-.575a.376.376,0,0,0,0-.163.248.248,0,0,0-.107-.106l-.106-.064-.518.625c-.035.05-.106.05-.206,0l-.078-.043C263.074,145.984,263.017,145.934,263.088,145.884Zm1.342-.611a.234.234,0,0,0,.185,0,.468.468,0,0,0,.206-.156.32.32,0,0,0,.1-.206.163.163,0,0,0-.1-.135l-.192-.114-.4.49Z",
    transform: "translate(-223.235 -137.366)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_215",
    "data-name": "Path 215",
    d: "M265.848,146.269c.5-.6.987-.76,1.469-.483s.476.71,0,1.306-.994.767-1.477.5S265.352,146.873,265.848,146.269Zm.582,1.044a1.576,1.576,0,0,0,.483-.433,1.348,1.348,0,0,0,.312-.525.248.248,0,0,0-.142-.284.39.39,0,0,0-.376,0,1.555,1.555,0,0,0-.476.433,1.221,1.221,0,0,0-.312.525.249.249,0,0,0,.142.291.4.4,0,0,0,.376,0Z",
    transform: "translate(-223.937 -137.786)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_216",
    "data-name": "Path 216",
    d: "M267.494,148.386l1.335-1.611a.163.163,0,0,1,.085-.057.171.171,0,0,1,.092,0l.447.256c.376.22.433.483.17.8a.71.71,0,0,1-.618.277h0a.5.5,0,0,1-.035.383l-.241.582c0,.043-.1.036-.2,0l-.085-.05c-.085-.05-.121-.1-.1-.142l.213-.49a.234.234,0,0,0,0-.163q0-.057-.106-.106l-.1-.057-.518.625c-.043.05-.114.043-.213,0l-.078-.043C267.486,148.485,267.458,148.435,267.494,148.386Zm1.349-.611a.206.206,0,0,0,.185,0,.49.49,0,0,0,.2-.149.348.348,0,0,0,.1-.213.177.177,0,0,0-.092-.135l-.192-.106-.4.483Z",
    transform: "translate(-224.517 -138.092)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_217",
    "data-name": "Path 217",
    d: "M270.142,149.99a.49.49,0,0,1-.128-.163.135.135,0,0,1,0-.121.476.476,0,0,1,.142-.078c.071,0,.114-.035.142,0a.452.452,0,0,1,.043.064.433.433,0,0,0,.085.114.412.412,0,0,0,.135.107.326.326,0,0,0,.27,0,.468.468,0,0,0,.263-.17c.163-.206.135-.369-.092-.5l-.241-.142a.061.061,0,0,1-.057-.064.1.1,0,0,1,.035-.085l.667-.71a.142.142,0,0,1,.092-.057.156.156,0,0,1,.092,0l.71.419s.043,0,.035.057a.135.135,0,0,1-.05.092l-.043.057a.277.277,0,0,1-.078.064.085.085,0,0,1-.071,0l-.518-.291-.376.4.071.043a.525.525,0,0,1,.163.909.767.767,0,0,1-.54.319.887.887,0,0,1-.554-.121A.986.986,0,0,1,270.142,149.99Z",
    transform: "translate(-225.249 -138.519)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_218",
    "data-name": "Path 218",
    d: "M272.126,150.82a1.7,1.7,0,0,1,.412-.752,2.087,2.087,0,0,1,.71-.589.639.639,0,0,1,.61,0,.433.433,0,0,1,.234.469,1.682,1.682,0,0,1-.412.76,2.173,2.173,0,0,1-.71.589.653.653,0,0,1-.618,0A.426.426,0,0,1,272.126,150.82Zm.6.22a.774.774,0,0,0,.234-.156,5.674,5.674,0,0,0,.653-.788.632.632,0,0,0,.092-.234.106.106,0,0,0-.064-.121.17.17,0,0,0-.156,0,.759.759,0,0,0-.227.156,4.2,4.2,0,0,0-.348.383,3.476,3.476,0,0,0-.305.412.6.6,0,0,0-.1.234.121.121,0,0,0,.064.114.17.17,0,0,0,.177,0Z",
    transform: "translate(-225.862 -138.873)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_219",
    "data-name": "Path 219",
    d: "M273.705,152.023q-.128-.149-.064-.234a.369.369,0,0,1,.135-.078q.1-.043.128,0a.178.178,0,0,1,.05.064.711.711,0,0,0,.092.135.5.5,0,0,0,.128.1.4.4,0,0,0,.27.05.412.412,0,0,0,.27-.163.334.334,0,0,0,.092-.263.376.376,0,0,0-.2-.213l-.106-.057a.057.057,0,0,1-.035-.057.163.163,0,0,1,.05-.1h0a.249.249,0,0,1,.092-.071.078.078,0,0,1,.078,0l.078.043a.376.376,0,0,0,.284.05.4.4,0,0,0,.227-.128.241.241,0,0,0,.071-.192.234.234,0,0,0-.135-.17.568.568,0,0,0-.149-.057h-.2a.1.1,0,0,1,0-.106.305.305,0,0,1,.043-.135c.043-.05.128-.064.248-.035a1.193,1.193,0,0,1,.369.142.539.539,0,0,1,.291.334.483.483,0,0,1-.121.4.611.611,0,0,1-.263.185.66.66,0,0,1-.312,0h0a.44.44,0,0,1,.1.305.561.561,0,0,1-.149.341.8.8,0,0,1-.312.241.767.767,0,0,1-.355.064.823.823,0,0,1-.362-.106A1.512,1.512,0,0,1,273.705,152.023Z",
    transform: "translate(-226.299 -139.16)",
    fill: "#455a64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--phone--inject-17-3",
    "data-name": "freepik--phone--inject-17",
    transform: "translate(1.316 22.063)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_220",
    "data-name": "Path 220",
    d: "M212.214,179.173l-2.627,1.519-3.642,2.13-12.636-7.3,3.826-2.208,3.315-1.917a6.318,6.318,0,0,0,2.179,2.272l6.389,3.706a3.237,3.237,0,0,0,1.285.433Z",
    transform: "translate(-186.736 -164.459)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_221",
    "data-name": "Path 221",
    d: "M212.214,179.173l-2.627,1.519-3.642,2.13-12.636-7.3,3.826-2.208,3.315-1.917a6.318,6.318,0,0,0,2.179,2.272l6.389,3.706a3.237,3.237,0,0,0,1.285.433Z",
    transform: "translate(-186.736 -164.459)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_222",
    "data-name": "Path 222",
    d: "M226.106,182.6v2.172a2.03,2.03,0,0,1-.958,1.69h0l-.554.327-6.084,3.549a2.243,2.243,0,0,0,1.335-1.931V186.22a1.469,1.469,0,0,0,.71-.17l5.26-3.038a.5.5,0,0,0,.291-.412Z",
    transform: "translate(-194.047 -167.708)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_223",
    "data-name": "Path 223",
    d: "M200.466,170.113l-3.315,1.917-2.953,1.7a3.818,3.818,0,0,1-.383-1.036l-.454-2.059h0a1.42,1.42,0,0,0,.71-.163l5.26-3.038a.532.532,0,0,0,.291-.376h0l.447,2.03a3.876,3.876,0,0,0,.4,1.022Z",
    transform: "translate(-186.75 -163.2)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_224",
    "data-name": "Path 224",
    d: "M209.142,181.452l-5.58-3.216a.589.589,0,0,1-.284-.348v-.064s-.227.71-.511,1.512-1.469.965-2.655.284l-6.389-3.706a6.041,6.041,0,0,1-2.6-3.308l-.454-2.066h0a1.512,1.512,0,0,1-.71-.163l-5.573-3.223a.49.49,0,0,1-.3-.4v2.769a5.991,5.991,0,0,0,1.065,2.8,16.228,16.228,0,0,0,4.87,4.5s11.713,6.779,13.935,8.043,3.926,1.264,4.593.88a2.243,2.243,0,0,0,1.335-1.931v-2.186a1.42,1.42,0,0,1-.745-.17Z",
    transform: "translate(-184.061 -163.11)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_225",
    "data-name": "Path 225",
    d: "M191.34,168.876l5.26-3.038a.433.433,0,0,0,0-.823l-5.573-3.223a1.576,1.576,0,0,0-1.42,0l-5.26,3.038a.433.433,0,0,0,0,.823l5.573,3.223a1.576,1.576,0,0,0,1.42,0Z",
    transform: "translate(-184.049 -161.622)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_226",
    "data-name": "Path 226",
    d: "M189.18,167.466c-1.37-.788-1.37-2.073,0-2.84a5.48,5.48,0,0,1,4.969,0c1.37.8,1.37,2.073,0,2.84A5.5,5.5,0,0,1,189.18,167.466Z",
    transform: "translate(-185.239 -162.321)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_62",
    "data-name": "Ellipse 62",
    cx: 0.369,
    cy: 0.213,
    rx: 0.369,
    ry: 0.213,
    transform: "translate(4.509 2.618)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_227",
    "data-name": "Path 227",
    d: "M189.977,166.289c.206,0,.341.128.305.241s-.22.2-.419.177-.334-.128-.305-.241S189.779,166.275,189.977,166.289Z",
    transform: "translate(-185.646 -162.976)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_228",
    "data-name": "Path 228",
    d: "M190.067,167.388a.5.5,0,0,1,.49.092c.092.106,0,.234-.156.284a.511.511,0,0,1-.5-.092C189.811,167.566,189.882,167.438,190.067,167.388Z",
    transform: "translate(-185.736 -163.287)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_229",
    "data-name": "Path 229",
    d: "M191.253,168.243a.54.54,0,0,1,.49-.092c.185.057.256.185.163.284a.525.525,0,0,1-.5.1C191.232,168.477,191.161,168.349,191.253,168.243Z",
    transform: "translate(-186.127 -163.509)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_230",
    "data-name": "Path 230",
    d: "M193.08,168.541c0-.121.106-.227.312-.241s.383.057.419.17-.106.227-.305.248S193.115,168.654,193.08,168.541Z",
    transform: "translate(-186.669 -163.559)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_231",
    "data-name": "Path 231",
    d: "M194.864,168.152c-.149-.085-.149-.22,0-.3a.561.561,0,0,1,.518,0c.142.078.142.213,0,.3A.561.561,0,0,1,194.864,168.152Z",
    transform: "translate(-187.154 -163.412)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_232",
    "data-name": "Path 232",
    d: "M195.871,167.238c-.206,0-.341-.128-.312-.241s.22-.2.426-.177.334.128.305.241S196.1,167.252,195.871,167.238Z",
    transform: "translate(-187.387 -163.129)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_233",
    "data-name": "Path 233",
    d: "M195.782,166.135a.511.511,0,0,1-.5-.092c-.092-.1,0-.227.163-.284a.511.511,0,0,1,.5.092C196.066,165.957,195.995,166.085,195.782,166.135Z",
    transform: "translate(-187.298 -162.814)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_234",
    "data-name": "Path 234",
    d: "M194.637,165.282a.547.547,0,0,1-.5.092c-.177-.057-.248-.185-.156-.284a.5.5,0,0,1,.49-.092C194.693,165.048,194.729,165.176,194.637,165.282Z",
    transform: "translate(-186.919 -162.593)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_235",
    "data-name": "Path 235",
    d: "M192.8,164.986c.035.121-.1.227-.305.248s-.39-.064-.419-.177.106-.227.305-.248S192.774,164.873,192.8,164.986Z",
    transform: "translate(-186.377 -162.546)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_236",
    "data-name": "Path 236",
    d: "M218.412,184.5l5.26-3.038a.433.433,0,0,0,0-.823l-5.58-3.216a1.576,1.576,0,0,0-1.42,0l-5.26,3.038a.433.433,0,0,0,0,.816l5.58,3.223A1.576,1.576,0,0,0,218.412,184.5Z",
    transform: "translate(-191.904 -166.156)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_237",
    "data-name": "Path 237",
    d: "M216.25,183.085c-1.37-.788-1.37-2.066,0-2.84a5.459,5.459,0,0,1,4.969,0c1.363.788,1.363,2.073,0,2.84a5.48,5.48,0,0,1-4.969,0Z",
    transform: "translate(-193.093 -166.851)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_238",
    "data-name": "Path 238",
    d: "M218.093,180.976a.163.163,0,0,1,0,.305.6.6,0,0,1-.518,0c-.149-.085-.149-.22,0-.305A.6.6,0,0,1,218.093,180.976Z",
    transform: "translate(-193.743 -167.22)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_239",
    "data-name": "Path 239",
    d: "M217.047,181.918c.2,0,.334.128.305.241s-.22.192-.419.177-.341-.128-.305-.248S216.848,181.9,217.047,181.918Z",
    transform: "translate(-193.499 -167.509)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_240",
    "data-name": "Path 240",
    d: "M217.132,182.989a.525.525,0,0,1,.5.092c.092.106,0,.234-.163.284a.5.5,0,0,1-.49-.092C216.883,183.188,216.983,183.06,217.132,182.989Z",
    transform: "translate(-193.591 -167.813)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241",
    "data-name": "Path 241",
    d: "M218.314,183.871a.511.511,0,0,1,.5-.092c.177.05.256.177.163.284a.532.532,0,0,1-.5.092C218.292,184.1,218.221,183.97,218.314,183.871Z",
    transform: "translate(-193.978 -168.042)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_242",
    "data-name": "Path 242",
    d: "M220.15,184.161c0-.114.106-.227.305-.241s.39.057.419.177-.1.22-.305.241A.389.389,0,0,1,220.15,184.161Z",
    transform: "translate(-194.522 -168.09)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_243",
    "data-name": "Path 243",
    d: "M221.956,183.772c-.142-.078-.142-.213,0-.3a.561.561,0,0,1,.518,0c.149.085.149.22,0,.3a.561.561,0,0,1-.518,0Z",
    transform: "translate(-195.016 -167.943)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_244",
    "data-name": "Path 244",
    d: "M222.974,182.827c-.2,0-.334-.128-.305-.241s.22-.2.419-.177.341.128.305.241A.366.366,0,0,1,222.974,182.827Z",
    transform: "translate(-195.252 -167.652)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_245",
    "data-name": "Path 245",
    d: "M222.892,181.764a.547.547,0,0,1-.5-.092c-.092-.106,0-.234.163-.291a.54.54,0,0,1,.49.092C223.14,181.579,223.069,181.707,222.892,181.764Z",
    transform: "translate(-195.163 -167.348)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_246",
    "data-name": "Path 246",
    d: "M221.714,180.872a.511.511,0,0,1-.5.092c-.177-.05-.256-.177-.163-.284a.511.511,0,0,1,.5-.092C221.714,180.659,221.8,180.787,221.714,180.872Z",
    transform: "translate(-194.773 -167.116)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_247",
    "data-name": "Path 247",
    d: "M219.872,180.617c0,.114-.106.22-.305.241s-.39-.064-.419-.177.1-.227.305-.241S219.837,180.5,219.872,180.617Z",
    transform: "translate(-194.231 -167.081)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Keyboard--inject-17",
    transform: "translate(61.494 99.275)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-17-4",
    "data-name": "freepik--shadow--inject-17",
    d: "M322.123,221.2l-19.55,11.358a2.286,2.286,0,0,1-2.08,0l-54.988-31.7a.639.639,0,0,1,0-1.207l19.543-11.358a2.3,2.3,0,0,1,2.087,0l54.988,31.7a.639.639,0,0,1,0,1.207Z",
    transform: "translate(-245.076 -186.447)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--keyboard--inject-17-2",
    "data-name": "freepik--keyboard--inject-17",
    transform: "translate(1.926)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_248",
    "data-name": "Path 248",
    d: "M247.79,196.689a.71.71,0,0,1,.433-.6l17.4-10.045a2.286,2.286,0,0,1,2.08,0l53.092,30.7a.71.71,0,0,1,.433.6v1.824a.71.71,0,0,1-.433.6L303.4,229.819a2.286,2.286,0,0,1-2.08,0l-53.1-30.66a.71.71,0,0,1-.433-.6Z",
    transform: "translate(-247.79 -185.797)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_249",
    "data-name": "Path 249",
    d: "M303.4,227.952l17.392-10a.632.632,0,0,0,0-1.2l-53.092-30.7a2.286,2.286,0,0,0-2.08,0l-17.4,10.045a.632.632,0,0,0,0,1.2l53.1,30.653a2.307,2.307,0,0,0,2.08.007Z",
    transform: "translate(-247.789 -185.797)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_250",
    "data-name": "Path 250",
    d: "M324.76,241.087v1.867a2.13,2.13,0,0,0,.98-.241l17.385-10.038a.71.71,0,0,0,.426-.6V230.24a.71.71,0,0,1-.426.6l-17.385,10A2.194,2.194,0,0,1,324.76,241.087Z",
    transform: "translate(-270.12 -198.691)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_251",
    "data-name": "Path 251",
    d: "M252.327,197.619h0l1.725-.994,2.336,1.349L254.656,199l-2.336-1.349Zm2.7-1.555h0l1.718-.994,1.839,1.058-1.732,1.029-1.831-1.058Zm.568,3.443h0l1.725-1,1.832,1.065-1.732,1.022-1.817-1.079Zm2.13-4.969,1.718-.994,2.967,1.718-1.732,1.022-2.953-1.739Zm.064,3.152,1.725-.994,1.42.845-1.732,1.029-1.427-.9Zm.568,3.436h0l1.718-.994,1.839,1.058-1.732,1.029-1.831-1.058Zm1.817-2.059,1.725-.994,1.455.845-1.732,1.029-1.455-.845Zm.248-6.091h0l1.725-.994,2.336,1.349-1.739.98-2.336-1.349Zm.71,9.747,1.725-.994,13.254,7.653-1.732,1.029-13.254-7.7Zm.5-5.942h0l1.725-.994,1.455.845-1.732,1.022-1.455-.838Zm.944,3.663,1.725-.994,1.455.845-1.732,1.029-1.455-.845Zm.561-9.023h0l1.725-.994,1.42.838-1.732,1.029-1.455-.838Zm.568,3.443,1.725-.994,1.455.838-1.732,1.029-1.455-.838Zm.312,3.294h0l1.725-.994,1.42.845-1.732,1.022-1.455-.838Zm.944,3.663,1.725-.994,1.455.816-1.732,1.029-1.455-.845Zm.561-9.023h0l1.725-.994,1.455.838-1.732,1.029-1.455-.838Zm.568,3.443,1.725-.994,1.455.838-1.732,1.029-1.455-.838Zm.312,3.294h0l1.725-.994,1.455.845-1.732,1.022-1.455-.894Zm0-10,1.725-.994,1.831,1.058-1.732,1.029-1.831-1.058Zm.944,13.665h0l1.725-.994,1.42.845-1.732,1.029-1.42-.845Zm.561-9.023h0l1.725-.994,1.455.838-1.732,1.029-1.455-.838Zm.568,3.443,1.725-.994,1.455.838-1.732,1.029-1.455-.838Zm.312,3.294h0l1.725-.994,1.455.845-1.732,1.022-1.455-.852Zm.944,3.663h0l1.725-.994,1.455.845-1.732,1.029-1.455-.845Zm.476-12.849,1.725-.994,1.455.838L271.65,192.6l-1.462-.894Zm.078,3.826h0l1.725-.994,1.455.838-1.732,1.029-1.455-.838Zm.575,3.443L272.58,198l1.42.838-1.732,1.029-1.42-.838Zm.312,3.294h0l1.725-.994,1.455.845-1.732,1.022-1.455-.838Zm.944,3.663h0l1.725-.994,1.455.845-1.732,1.029-1.455-.93Zm.476-12.849,1.725-.994,1.42.838L274,193.978l-1.42-.838Zm.078,3.826h0l1.725-.994,1.42.845-1.711.973-1.42-.838Zm.575,3.443,1.725-.994,1.455.838-1.732,1.029-1.455-.838Zm.312,3.294h0l1.725-.994,1.42.845-1.7.965-1.42-.838Zm.944,3.663h0l1.725-.994,1.455.845-1.732,1.029-1.455-.887Zm.476-12.849,1.725-.994,1.455.838-1.732,1.029-1.455-.838Zm.085,3.826,1.725-.994,1.455.845-1.732,1.022-1.455-.838Zm.249,12.565h0l1.718-1,1.831,1.065-1.732,1.029Zm.305-9.165,1.725-.994,1.455.838-1.732,1.029-1.455-.838Zm.312,3.294h0l1.725-.994,1.455.845-1.718,1.051-1.455-.838Zm.944,3.663h0l1.725-.994,1.42.845-1.654,1.015-1.42-.845Zm.476-12.849,1.725-.994,1.455.838-1.725,1.015-1.455-.838Zm.085,3.826h0l1.725-.994,1.455.845-1.732,1.022-1.455-.838Zm.568,3.443,1.725-.994,1.477.831-1.732,1.029-1.455-.838Zm.071,9.378h0l1.718-.994,1.839,1.058-1.739,1.029-1.831-1.058Zm.241-6.084h0l1.725-.994,1.455.845-1.711,1.015-1.455-.838Zm.944,3.663h0l1.725-.994,1.455.845-1.732,1.029-1.455-.845Zm.561-9.023h0l1.725-.994,1.455.838-1.732,1.029-1.455-.838Zm.568,3.443,1.725-.994,1.42.838-1.732,1.029-1.42-.838Zm.312,3.294h0l1.725-.994,1.455.845-1.732,1.022-1.455-.838Zm.071-9.938h0l1.718-.994,1.462.845-1.739,1.029-1.455-.845Zm.064,16.271h0l1.718-.994,1.839,1.058-1.725.98-1.831-1.058Zm.809-2.648h0l1.725-.994,1.455.845-1.718,1-1.455-.845Zm.561-9.016,1.725-.994,1.42.838-1.732,1.029-1.42-.838Zm.568,3.443,1.725-.994,1.455.838-1.732,1.029-1.448-.838Zm.312,3.294h0l1.725-.994,1.42.845-1.732,1.022-1.42-.838Zm.071-9.938h0l1.718-.994,1.462.845-1.739,1.029-1.455-.845Zm.44,16.491h0l1.718-1,2.336,1.349-1.732,1.029-2.336-1.349Zm.433-2.84h0l1.725-.994,4.607,2.541-1.732,1.029-4.586-2.634Zm.561-9.023,1.725-.994,1.455.845-1.732,1.022-1.448-.951Zm.568,3.443,1.725-.994,1.455.838-1.732,1.029-1.455-.838Zm.312,3.294h0l1.725-.994,1.455.845-1.732,1.022-1.455-.923Zm.071-9.938,1.718-.994,1.462.845-1.739,1.029-1.455-.845Zm1.42,4.6,1.725-.994,1.455.845-1.732,1.022-1.434-.93Zm.383,12.679,1.725-.994,1.455.838-1.7.909-1.455-.838Zm.185-9.229,1.725-.994,1.455.838-1.7.909-1.455-.838Zm.312,3.294h0l1.725-.994,1.327.767a.873.873,0,0,0,.419.085.986.986,0,0,0,.447-.085l2.257-1.306,1.711.987-4.43,2.584-3.464-2Zm.071-9.938h0l1.718-.994,1.462.845-1.739,1.029-1.42-.845Zm1.42,4.607,1.725-.994,1.455.845-1.732,1.022-1.455-.838Zm.39,12.679,1.725-.994,1.42.838-1.661.916-1.42-.838Zm.177-9.229h0l1.718-.994,1.42.838-1.654.916-1.42-.838Zm1.42-6.07h0l1.725-.994,1.455.838-1.732,1.029-1.455-.838Zm.4,4,1.725-.994,1.42.845-1.661.845-1.42-.838Zm.383,12.679,1.725-.994,1.455.838-1.732,1.029-1.455-.838Zm.312-2.932,1.725-.994,1.455.845-1.732,1.029-1.455-.845Zm1.292-12.373h0l1.725-.994,1.42.838-1.732,1.029-1.42-.838Zm.4,4,1.725-.994,2.591,1.491-1.739,1.029-2.584-1.491Zm.887,12.97h0l1.725-.994,3.84,2.215-1.732,1.029-3.84-2.215Zm.433-9.094h0l1.718-.994,1.462.845-1.732,1.022-1.462-.838Zm.667-6.5h0l1.725-.994,1.455.838-1.732,1.029-1.427-.987Zm1.6,14.042,1.718-.994,1.462.845-1.732,1.029-1.455-.845Zm.121-6.162h0l1.718-.994,1.462.838-1.739,1.029-1.455-.838Zm.312-2.932,1.725-.994,1.455.838-1.732,1.029-1.455-.838Zm.355-3.549h0l1.725-.994,1.455.838-1.732,1.029-1.413-1.036Zm1.285,16.973,1.725-.994,1.455.838-1.732,1.029-1.413-.973Zm.312-2.932,1.718-.994,1.462.845-1.69.852L300.1,222.1Zm.121-6.162h0l1.718-.994,1.462.845-1.739,1.022-1.42-.838Zm.192,3.223h0l1.718-.994,1.455.845-1.732,1.022-1.455-.838Zm.121-6.155,1.725-.994,1.455.838-1.732,1.029-1.42-.838Zm.887-3.265,1.725-.994,1.455.838-1.732,1.029-1.42-.838Zm.752,16.668,4.415-2.556,1.462.845-4.43,2.584-1.455-.838Zm.312-2.932,1.718-.994,1.462.845-1.718.852-1.42-.845Zm.312-2.939h0l1.718-.994,1.455.845-1.732,1.022-1.455-.838Zm.121-6.155,1.725-.994,1.455.838-1.732,1.029-1.42-.973Zm.192,3.223,1.725-.994,1.455.838-1.732,1.029-1.455-.838Zm.71-6.488,1.725-.994,1.455.838-1.732,1.029-1.455-.838Zm1.377,10.8h0l1.718-.994,1.42.845-1.732,1.022-1.455-.838Zm.312-2.932,1.725-.994,1.42.838L306.889,220l-1.42-.838Zm.305-2.932,1.725-.994,1.42.838-1.732,1.029-1.42-.845Zm.39-3.549,1.725-.994,1.455.838-1.732,1.029-1.455-.838Zm1.377,10.8h0l4.415-2.548,1.455.838L309,224.318l-1.462-.845Zm.312-2.932,1.725-.994,1.455.838-1.732,1.029-1.455-.838Zm.305-2.932,1.725-.994,1.455.838-1.732,1.029-1.441-1.022Zm1.583-3.67h0l.71-.433,1.42.845-.71.461-1.455-.838Zm.8,5.047,1.725-.994,1.455.838L312,219.825l-1.455-.845Zm1.6-3.819h0l.71-.433,1.455.845-.745.461-1.42-.838Zm.8,5.047,1.725-.994,1.455.838-1.732,1.029-1.455-.838Zm1.583-3.67h0l.71-.433,1.455.845-.745.461-1.391-.831Zm2.385,1.377h0l.71-.433,1.455.845-.745.461-1.455-.838Z",
    transform: "translate(-249.104 -186.593)",
    fill: "#1999cf"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-17",
    transform: "translate(95.322)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-17-5",
    "data-name": "freepik--shadow--inject-17",
    d: "M381.231,212.2l11.3-6.517c1.7-.987,1.7-2.57,0-3.549L311.449,155.32a6.794,6.794,0,0,0-6.148,0L294,161.843c-1.7.98-1.7,2.57,0,3.549l81.083,46.81a6.751,6.751,0,0,0,6.148,0Z",
    transform: "translate(-292.727 -77.467)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Monitor--inject-17",
    transform: "translate(1.107)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_252",
    "data-name": "Path 252",
    d: "M337.612,200.538l-12.458-7.212a3.221,3.221,0,0,1-1.924-2.683V188.91l11.72-6.652a2.733,2.733,0,0,0,1.242-2.13V164.76l21.751,12.572v15.355a2.747,2.747,0,0,1-1.235,2.13l-9.789,5.679a10.272,10.272,0,0,1-9.307.043Z",
    transform: "translate(-302.684 -80.419)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_253",
    "data-name": "Path 253",
    d: "M364.77,199.566v1.725L368.752,199a2.754,2.754,0,0,0,1.242-2.13V181.492l-4.146-2.392c-.085,1.058-.177,2.13-.263,3.2l2.9,1.7v12a2.747,2.747,0,0,1-1.235,2.13Z",
    transform: "translate(-314.735 -84.579)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_254",
    "data-name": "Path 254",
    d: "M356.427,192.846a2.733,2.733,0,0,1-1.242,2.13L346.9,199.81a10.272,10.272,0,0,1-9.3,0l-12.458-7.2c-2.57-1.484-2.57-3.89,0-5.374l8.3-4.834a2.747,2.747,0,0,0,1.235-2.13v-12l21.751,12.586Z",
    transform: "translate(-302.68 -81.437)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_255",
    "data-name": "Path 255",
    d: "M334.06,183.88h0l2.527-1.462a2.747,2.747,0,0,0,1.235-2.13V168.27l21.751,12.586v12a2.733,2.733,0,0,1-1.242,2.13l-2.477,1.42Z",
    transform: "translate(-305.826 -81.437)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_256",
    "data-name": "Path 256",
    d: "M382.975,173.921a3.3,3.3,0,0,1-3-.057l-84.136-48.57a3.422,3.422,0,0,1-1.548-2.683V48.967a2.911,2.911,0,0,1,4.458-2.57l84.129,48.57a3.422,3.422,0,0,1,1.548,2.683v73.644A3.315,3.315,0,0,1,382.975,173.921Z",
    transform: "translate(-294.287 -45.951)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_257",
    "data-name": "Path 257",
    d: "M379.98,174.64l-84.143-48.57a3.422,3.422,0,0,1-1.548-2.683V49.742c0-.987.71-1.42,1.548-.894l84.143,48.57a3.429,3.429,0,0,1,1.555,2.69v73.636C381.521,174.732,380.825,175.137,379.98,174.64Z",
    transform: "translate(-294.288 -46.726)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_258",
    "data-name": "Path 258",
    d: "M379.8,166.626v-63.6a2.03,2.03,0,0,0-.93-1.611L299.31,55.48c-.511-.291-.93-.05-.93.54v63.6a2.059,2.059,0,0,0,.93,1.611l79.557,45.93C379.385,167.457,379.8,167.216,379.8,166.626Z",
    transform: "translate(-295.475 -48.679)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_259",
    "data-name": "Path 259",
    d: "M352.7,182.349a3.23,3.23,0,0,1,1.42,2.52c0,.93-.646,1.306-1.42.838a3.194,3.194,0,0,1-1.455-2.513C351.24,182.264,351.893,181.888,352.7,182.349Z",
    transform: "translate(-310.81 -85.465)",
    fill: "#1999cf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_260",
    "data-name": "Path 260",
    d: "M419.079,116.63l-2.9,1.682a3.288,3.288,0,0,1,.454,1.526v73.828c0,.9-.575,1.313-1.32,1.008a2.9,2.9,0,0,0,4.259-2.69V118.156A3.223,3.223,0,0,0,419.079,116.63Z",
    transform: "translate(-329.398 -66.456)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Text--inject-17",
    transform: "translate(21.043 44.566)",
    opacity: 0.174
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_264",
    "data-name": "Path 264",
    d: "M338.744,139.7a.568.568,0,0,1,.218.265.833.833,0,0,1,.095.388v1.895a.351.351,0,0,1-.095.275.171.171,0,0,1-.218,0l-5.381-3.117a.521.521,0,0,1-.218-.265.948.948,0,0,1-.095-.379V127.442a.388.388,0,0,1,.095-.284.171.171,0,0,1,.218,0l5.3,3.06a.634.634,0,0,1,.218.265.948.948,0,0,1,.085.388v1.895a.379.379,0,0,1-.085.275.171.171,0,0,1-.218,0l-3.505-2.027v1.895L338.4,134.8a.521.521,0,0,1,.218.265.815.815,0,0,1,.095.388V137.3a.36.36,0,0,1-.095.284.171.171,0,0,1-.218,0l-3.249-1.895v1.961Z",
    transform: "translate(-333.049 -127.118)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_265",
    "data-name": "Path 265",
    d: "M344.15,133.379a6.51,6.51,0,0,1,1.345,1.014,5.912,5.912,0,0,1,1,1.317,6.147,6.147,0,0,1,.635,1.62,7.579,7.579,0,0,1,.227,1.895,4.416,4.416,0,0,1-.351,1.97,1.3,1.3,0,0,1-1,.748l1.412,4.974a1.057,1.057,0,0,1,0,.218.275.275,0,0,1-.076.227.133.133,0,0,1-.171,0l-1.544-.891a.7.7,0,0,1-.322-.341,3.279,3.279,0,0,1-.161-.407l-1.26-4.472-1.042-.606v3.789a.36.36,0,0,1-.095.284.171.171,0,0,1-.218,0l-1.487-.862a.635.635,0,0,1-.218-.265.947.947,0,0,1-.085-.388V131.892a.408.408,0,0,1,.085-.284.171.171,0,0,1,.218,0Zm-1.269,4.557,1.279.739a1.014,1.014,0,0,0,.8.18c.208-.066.313-.351.313-.834a2.122,2.122,0,0,0-.313-1.2,2.349,2.349,0,0,0-.8-.73l-1.279-.739Z",
    transform: "translate(-333.454 -127.353)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_266",
    "data-name": "Path 266",
    d: "M352.49,138.19a6.129,6.129,0,0,1,2.349,2.331,6.413,6.413,0,0,1,.635,1.62,7.713,7.713,0,0,1,.227,1.895,4.31,4.31,0,0,1-.36,1.98,1.279,1.279,0,0,1-.995.739l1.412,4.983a.944.944,0,0,1,0,.208.275.275,0,0,1-.076.227.133.133,0,0,1-.171,0l-1.544-.947a.767.767,0,0,1-.332-.341c-.057-.142-.114-.275-.152-.407l-1.26-4.472-1.042-.606v3.789a.379.379,0,0,1-.095.275.17.17,0,0,1-.218,0l-1.487-.862a.578.578,0,0,1-.218-.265.948.948,0,0,1-.085-.379V136.7a.379.379,0,0,1,.085-.275.171.171,0,0,1,.218,0Zm-1.279,4.557,1.279.748a1.033,1.033,0,0,0,.8.171c.208-.066.313-.341.313-.834a2.066,2.066,0,0,0-.313-1.194,2.474,2.474,0,0,0-.8-.739l-1.279-.739Z",
    transform: "translate(-333.893 -127.606)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_267",
    "data-name": "Path 267",
    d: "M357.169,145.524a5.863,5.863,0,0,1,.275-1.686,2.4,2.4,0,0,1,.7-1.1,1.61,1.61,0,0,1,1.09-.388,3.06,3.06,0,0,1,1.478.483,5.533,5.533,0,0,1,1.478,1.222,8.06,8.06,0,0,1,1.1,1.648,8.971,8.971,0,0,1,.692,1.895,10.577,10.577,0,0,1,.284,2.008v3.117a6.2,6.2,0,0,1-.284,1.686,2.481,2.481,0,0,1-.692,1.118,1.629,1.629,0,0,1-1.1.379,3.278,3.278,0,0,1-1.478-.483,5.949,5.949,0,0,1-1.478-1.232,7.475,7.475,0,0,1-1.089-1.639,9.475,9.475,0,0,1-.7-1.895,9.843,9.843,0,0,1-.275-2.008c0-.483,0-1,0-1.554S357.151,146.016,357.169,145.524Zm4.993,5.912v-2.946a5.364,5.364,0,0,0-.123-.872,3.589,3.589,0,0,0-.275-.8,3.215,3.215,0,0,0-.436-.682,2.141,2.141,0,0,0-.616-.512,1.288,1.288,0,0,0-.606-.2.673.673,0,0,0-.445.18,1.07,1.07,0,0,0-.265.483,2.718,2.718,0,0,0-.123.73c0,.189,0,.417,0,.663v2.283a4.736,4.736,0,0,0,.388,1.677,2.567,2.567,0,0,0,1.052,1.184q.711.417,1.052,0a2.028,2.028,0,0,0,.4-1.194Z",
    transform: "translate(-334.318 -127.92)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_268",
    "data-name": "Path 268",
    d: "M369.44,147.979a6.507,6.507,0,0,1,1.345,1.014,6.129,6.129,0,0,1,1.639,2.937,7.712,7.712,0,0,1,.227,1.895,4.49,4.49,0,0,1-.351,1.98,1.3,1.3,0,0,1-1,.739l1.412,4.983a.948.948,0,0,1,0,.208.312.312,0,0,1-.066.227.142.142,0,0,1-.18,0l-1.544-.891a.7.7,0,0,1-.322-.341,2.783,2.783,0,0,1-.161-.407l-1.26-4.472-1.042-.606v3.789a.35.35,0,0,1-.095.275.17.17,0,0,1-.218,0l-1.487-.862a.512.512,0,0,1-.208-.265.815.815,0,0,1-.095-.388v-11.3a.351.351,0,0,1,.095-.275c.057-.066.123-.066.208,0Zm-1.279,4.557,1.279.739a1.014,1.014,0,0,0,.8.18c.208-.066.313-.341.313-.834a2.065,2.065,0,0,0-.313-1.194,2.283,2.283,0,0,0-.8-.739l-1.279-.739Z",
    transform: "translate(-334.785 -128.121)",
    fill: "#455a64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Text--inject-17-2",
    "data-name": "freepik--Text--inject-17",
    transform: "translate(20.043 48.209)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_264-2",
    "data-name": "Path 264",
    d: "M338.453,139.058a.539.539,0,0,1,.207.252.791.791,0,0,1,.09.369v1.8a.333.333,0,0,1-.09.261.162.162,0,0,1-.207,0l-5.106-2.958a.494.494,0,0,1-.207-.252.9.9,0,0,1-.09-.36V127.425a.369.369,0,0,1,.09-.27.162.162,0,0,1,.207,0l5.025,2.9a.6.6,0,0,1,.207.252.9.9,0,0,1,.081.369v1.8a.36.36,0,0,1-.081.261.162.162,0,0,1-.207,0l-3.326-1.924v1.8l3.083,1.8a.5.5,0,0,1,.207.252.773.773,0,0,1,.09.369v1.753a.341.341,0,0,1-.09.27.162.162,0,0,1-.207,0l-3.083-1.8v1.861Z",
    transform: "translate(-333.049 -127.118)",
    fill: "#1999cf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_265-2",
    "data-name": "Path 265",
    d: "M343.976,133.287a6.177,6.177,0,0,1,1.277.962,5.611,5.611,0,0,1,.953,1.25,5.833,5.833,0,0,1,.6,1.537,7.191,7.191,0,0,1,.216,1.8,4.19,4.19,0,0,1-.333,1.87,1.232,1.232,0,0,1-.953.71l1.339,4.72a1,1,0,0,1,0,.207.261.261,0,0,1-.072.216.126.126,0,0,1-.162,0l-1.465-.845a.665.665,0,0,1-.306-.324,3.115,3.115,0,0,1-.153-.387l-1.2-4.243-.989-.575v3.6a.342.342,0,0,1-.09.27.162.162,0,0,1-.207,0l-1.411-.818a.6.6,0,0,1-.207-.252.9.9,0,0,1-.081-.369V131.875a.387.387,0,0,1,.081-.27.162.162,0,0,1,.207,0Zm-1.2,4.324,1.214.7a.962.962,0,0,0,.755.171c.2-.063.3-.333.3-.791a2.013,2.013,0,0,0-.3-1.142,2.229,2.229,0,0,0-.755-.692l-1.214-.7Z",
    transform: "translate(-333.826 -127.568)",
    fill: "#1999cf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_266-2",
    "data-name": "Path 266",
    d: "M352.316,138.1a5.816,5.816,0,0,1,2.229,2.211,6.085,6.085,0,0,1,.6,1.537,7.318,7.318,0,0,1,.216,1.8,4.09,4.09,0,0,1-.342,1.879,1.213,1.213,0,0,1-.944.7l1.339,4.729a.9.9,0,0,1,0,.2.261.261,0,0,1-.072.216.126.126,0,0,1-.162,0l-1.465-.9a.728.728,0,0,1-.315-.324c-.054-.135-.108-.261-.144-.387l-1.2-4.243-.989-.575v3.6a.36.36,0,0,1-.09.261.162.162,0,0,1-.207,0l-1.411-.818a.548.548,0,0,1-.207-.252.9.9,0,0,1-.081-.36v-10.68a.359.359,0,0,1,.081-.261.162.162,0,0,1,.207,0Zm-1.214,4.324,1.214.71a.98.98,0,0,0,.755.162c.2-.063.3-.324.3-.791a1.961,1.961,0,0,0-.3-1.133,2.348,2.348,0,0,0-.755-.7l-1.214-.7Z",
    transform: "translate(-334.668 -128.055)",
    fill: "#1999cf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_267-2",
    "data-name": "Path 267",
    d: "M357.169,145.361a5.565,5.565,0,0,1,.261-1.6,2.274,2.274,0,0,1,.665-1.043,1.528,1.528,0,0,1,1.034-.369,2.9,2.9,0,0,1,1.4.458,5.251,5.251,0,0,1,1.4,1.16,7.649,7.649,0,0,1,1.043,1.564,8.512,8.512,0,0,1,.656,1.8,10.035,10.035,0,0,1,.27,1.906v2.958a5.879,5.879,0,0,1-.27,1.6,2.355,2.355,0,0,1-.656,1.061,1.546,1.546,0,0,1-1.043.36,3.111,3.111,0,0,1-1.4-.458,5.645,5.645,0,0,1-1.4-1.169,7.093,7.093,0,0,1-1.034-1.555,8.991,8.991,0,0,1-.665-1.8,9.341,9.341,0,0,1-.261-1.906c0-.458,0-.953,0-1.474S357.151,145.829,357.169,145.361Zm4.738,5.61v-2.8a5.09,5.09,0,0,0-.117-.827,3.406,3.406,0,0,0-.261-.755,3.05,3.05,0,0,0-.414-.647,2.032,2.032,0,0,0-.584-.485,1.222,1.222,0,0,0-.575-.189.638.638,0,0,0-.422.171,1.016,1.016,0,0,0-.252.458,2.579,2.579,0,0,0-.117.692c0,.18,0,.4,0,.629v2.167a4.494,4.494,0,0,0,.369,1.591,2.436,2.436,0,0,0,1,1.124q.674.4,1,0a1.924,1.924,0,0,0,.378-1.133Z",
    transform: "translate(-335.485 -128.657)",
    fill: "#1999cf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_268-2",
    "data-name": "Path 268",
    d: "M369.266,147.887a6.176,6.176,0,0,1,1.277.962,5.816,5.816,0,0,1,1.555,2.787,7.318,7.318,0,0,1,.216,1.8,4.261,4.261,0,0,1-.333,1.879,1.232,1.232,0,0,1-.953.7l1.339,4.729a.9.9,0,0,1,0,.2.3.3,0,0,1-.063.216.135.135,0,0,1-.171,0l-1.465-.845a.665.665,0,0,1-.306-.324,2.639,2.639,0,0,1-.153-.387l-1.2-4.243-.989-.575v3.6a.333.333,0,0,1-.09.261.162.162,0,0,1-.207,0l-1.411-.818a.486.486,0,0,1-.2-.252.773.773,0,0,1-.09-.369V146.475a.333.333,0,0,1,.09-.261c.054-.063.117-.063.2,0Zm-1.214,4.324,1.214.7a.962.962,0,0,0,.755.171c.2-.063.3-.324.3-.791a1.96,1.96,0,0,0-.3-1.133,2.166,2.166,0,0,0-.755-.7l-1.214-.7Z",
    transform: "translate(-336.381 -129.043)",
    fill: "#1999cf"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Mouse--inject-17",
    transform: "translate(134.228 135.451)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_287",
    "data-name": "Path 287",
    d: "M349.079,249.306l6.694,3.862a7.354,7.354,0,0,0,7.383-.39l11.032-8.057c1.973-1.42,1.86-3.549-.248-4.8l-3.358-1.945a9.093,9.093,0,0,0-7.752-.234l-13.623,7.383C347.027,246.225,346.97,248.092,349.079,249.306Z",
    transform: "translate(-347.534 -236.824)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_288",
    "data-name": "Path 288",
    d: "M374.83,241.189l-7.638,5.97-5.629,4.408a5.2,5.2,0,0,1-4.472-.135l-5.984-3.45h0a4.259,4.259,0,0,1-1.214-6.062l.177-.241a7.965,7.965,0,0,1,4.813-3.053l3.038-.611c4.905-.994,8.937-1.477,9.406-1.164l7.5,4.352Z",
    transform: "translate(-347.992 -236.757)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_289",
    "data-name": "Path 289",
    d: "M374.572,244.857l.426-.341-6.73-3.883,5.892-1.824-.6-.348-5.892,1.824L363.69,238l-.76.149Z",
    transform: "translate(-352.001 -237.118)",
    fill: "#1999cf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_290",
    "data-name": "Path 290",
    d: "M366.573,252.945h.035l5.36-3.869,7.241-5.232v-.88a.071.071,0,0,0-.035-.064h-.043c-.54-.185-3.677.752-7.468,2.265l-2.513.994a8.007,8.007,0,0,0-5.04,7.454v.135a4.969,4.969,0,0,0,1.8-.433Z",
    transform: "translate(-352.343 -238.533)",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Chair--inject-17",
    transform: "translate(29.626 128.435)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--chair--inject-17-2",
    "data-name": "freepik--chair--inject-17"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_291",
    "data-name": "Path 291",
    d: "M98.071,223.438l-3.571.1-2.96-39.661,3.564-.106Z",
    transform: "translate(-52.936 -168.418)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_292",
    "data-name": "Path 292",
    d: "M55.091,247.028l-3.564.1L48.56,207.466l3.571-.106Z",
    transform: "translate(-40.467 -175.262)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_293",
    "data-name": "Path 293",
    d: "M54.046,268H48.14L40.8,323.009h0a.71.71,0,0,0,.426.653,2.343,2.343,0,0,0,2.13,0,.809.809,0,0,0,.419-.511h0Z",
    transform: "translate(-38.216 -192.855)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_294",
    "data-name": "Path 294",
    d: "M103.489,239.19H97.575L89,300.567h0a.71.71,0,0,0,.433.646,2.286,2.286,0,0,0,2.13,0,.774.774,0,0,0,.419-.5h0Z",
    transform: "translate(-52.2 -184.497)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_295",
    "data-name": "Path 295",
    d: "M167.136,328.3l-10.2-60.3H151l13.147,60.418h0a.774.774,0,0,0,.419.5,2.3,2.3,0,0,0,2.13,0,.71.71,0,0,0,.426-.646Z",
    transform: "translate(-70.187 -192.855)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_296",
    "data-name": "Path 296",
    d: "M113.693,359.1l-8.59-61.37H99.19l11.536,61.512h0a.8.8,0,0,0,.419.511,2.343,2.343,0,0,0,2.13,0,.71.71,0,0,0,.426-.653Z",
    transform: "translate(-55.156 -201.48)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_297",
    "data-name": "Path 297",
    d: "M156.935,268H151l2.407,11.046q2.016-1.668,3.926-3.429a3.819,3.819,0,0,0,.71-.944Z",
    transform: "translate(-70.187 -192.855)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_298",
    "data-name": "Path 298",
    d: "M50.719,268l-1.029,7.333a4.749,4.749,0,0,0,1.143,1.995c1.1,1.008,2.265,2.023,3.471,3.038L56.626,268Z",
    transform: "translate(-40.795 -192.855)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_299",
    "data-name": "Path 299",
    d: "M106.289,306.185,105.1,297.73H99.19l1.931,10.3C102.881,307.441,104.6,306.824,106.289,306.185Z",
    transform: "translate(-55.156 -201.48)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_300",
    "data-name": "Path 300",
    d: "M86.64,285.1c16.718-5.537,30.234-13.651,41.259-23.788a4.728,4.728,0,0,0,1.327-3.06v-3.187a4.054,4.054,0,0,0-1.42-2.9A100.32,100.32,0,0,0,86.732,234.8a8.732,8.732,0,0,0-3.549.2q-21.169,6.453-32.5,18.6a5.367,5.367,0,0,0-1.214,3.173v3.187a4.707,4.707,0,0,0,1.327,3.06c8.462,7.809,20.587,15.795,32.5,21.829A5.033,5.033,0,0,0,86.64,285.1Z",
    transform: "translate(-40.731 -183.195)",
    fill: "#1999cf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_301",
    "data-name": "Path 301",
    d: "M143.65,255.06v3.187a4.777,4.777,0,0,1-1.327,3.067,111.8,111.8,0,0,1-41.259,23.781,4.7,4.7,0,0,1-1.874.149V234.728a7.673,7.673,0,0,1,1.931.078,99.939,99.939,0,0,1,41.074,17.357A4.025,4.025,0,0,1,143.65,255.06Z",
    transform: "translate(-55.156 -183.194)",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_302",
    "data-name": "Path 302",
    d: "M84.757,234.74v50.515a4.465,4.465,0,0,1-1.491-.4c-11.933-6.034-24.037-14.034-32.506-21.822a4.806,4.806,0,0,1-1.32-3.067v-3.194a5.246,5.246,0,0,1,1.221-3.159Q61.984,241.463,83.152,235a7.809,7.809,0,0,1,1.6-.263Z",
    transform: "translate(-40.723 -183.206)",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_303",
    "data-name": "Path 303",
    d: "M51.064,256.225c8.462,7.809,20.587,15.774,32.5,21.808a5.083,5.083,0,0,0,3.365.248,111.351,111.351,0,0,0,41.259-23.746,1.462,1.462,0,0,0-.128-2.328A100.319,100.319,0,0,0,86.984,234.85a8.732,8.732,0,0,0-3.549.2q-21.169,6.453-32.5,18.578a1.846,1.846,0,0,0,.128,2.6Z",
    transform: "translate(-41.019 -183.21)",
    fill: "#1999cf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_304",
    "data-name": "Path 304",
    d: "M51.064,256.225c8.462,7.809,20.587,15.774,32.5,21.808a5.083,5.083,0,0,0,3.365.248,111.351,111.351,0,0,0,41.259-23.746,1.462,1.462,0,0,0-.128-2.328A100.319,100.319,0,0,0,86.984,234.85a8.732,8.732,0,0,0-3.549.2q-21.169,6.453-32.5,18.578a1.846,1.846,0,0,0,.128,2.6Z",
    transform: "translate(-41.019 -183.21)",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_305",
    "data-name": "Path 305",
    d: "M38.26,187.79a65.63,65.63,0,0,1,44.375-25.62,6.055,6.055,0,0,1,3.28.625,3.386,3.386,0,0,1,1.477,2.676v13.417a2.13,2.13,0,0,1-1.8,2.052,65.794,65.794,0,0,0-44.375,25.62,2.066,2.066,0,0,1-2.577.589,3.365,3.365,0,0,1-1.477-2.669V191.055a6.2,6.2,0,0,1,1.1-3.265Z",
    transform: "translate(-37.16 -162.145)",
    fill: "#1999cf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_306",
    "data-name": "Path 306",
    d: "M50.3,207.968,37.458,200.55a5.679,5.679,0,0,0-.3,1.647v13.424a3.365,3.365,0,0,0,1.477,2.669,2.066,2.066,0,0,0,2.577-.589,71.782,71.782,0,0,1,9.087-9.733Z",
    transform: "translate(-37.16 -173.287)",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_307",
    "data-name": "Path 307",
    d: "M50.422,196.826A65.492,65.492,0,0,1,85.71,180.939a2.13,2.13,0,0,0,1.8-2.052V165.471a3.386,3.386,0,0,0-1.477-2.676,6.055,6.055,0,0,0-3.28-.625,65.645,65.645,0,0,0-44.375,25.62,5.558,5.558,0,0,0-.8,1.619Z",
    transform: "translate(-37.282 -162.145)",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308",
    "data-name": "Path 308",
    d: "M42.42,207.26A65.794,65.794,0,0,1,86.8,181.64a2.13,2.13,0,0,0,1.8-2.052V166.172a1.555,1.555,0,0,0-1.8-1.59A65.651,65.651,0,0,0,42.42,190.2a6.162,6.162,0,0,0-1.1,3.265v13.417C41.32,207.892,41.8,208.048,42.42,207.26Z",
    transform: "translate(-38.367 -162.846)",
    fill: "#1999cf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309",
    "data-name": "Path 309",
    d: "M42.42,207.26A65.794,65.794,0,0,1,86.8,181.64a2.13,2.13,0,0,0,1.8-2.052V166.172a1.555,1.555,0,0,0-1.8-1.59A65.651,65.651,0,0,0,42.42,190.2a6.162,6.162,0,0,0-1.1,3.265v13.417C41.32,207.892,41.8,208.048,42.42,207.26Z",
    transform: "translate(-38.367 -162.846)",
    opacity: 0.4
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-17",
    transform: "translate(25.257 68.006)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-17-2",
    "data-name": "freepik--character--inject-17"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_310",
    "data-name": "Path 310",
    d: "M143.07,318.026s-5.1,11.216-5.516,15.7c-.433,4.678-1.626,6.183-1.029,11.308.128,1.122.618,3.365.71,4.259a1.335,1.335,0,0,1-1.271,1.619c-2.052.341-5.274-3.613-6.716-7.809A121.127,121.127,0,0,1,125.8,328.3a6.389,6.389,0,0,1,.774-3.258,10,10,0,0,1,1-1.661c.752-2.009,1.228-5.878,1.9-8.519Z",
    transform: "translate(-58.505 -146.021)",
    fill: "#ffa8a7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_311",
    "data-name": "Path 311",
    d: "M119.752,339.56a4.728,4.728,0,0,0-.6,1.519c-.085.93,1.9,4.1,2.683,5.246a7.482,7.482,0,0,1,1.313,5.388,12.837,12.837,0,0,0,2.84,8.462,20.587,20.587,0,0,0,9.938,7.1c4.877,1.718,6.716-.71,6.716-.71s1.626-2.321.71-3.336S119.752,339.56,119.752,339.56Z",
    transform: "translate(-56.576 -153.187)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_312",
    "data-name": "Path 312",
    d: "M125.91,326.839a.878.878,0,0,0-.823.39c-.149.17-1.136,2.35-1.931,3.486s-2.84,3.273-3.166,5.154c.994,3.706,4.33,6.389,4.707,9.86s.284,7.489,5.424,11.926,10.584,5.09,12.593,4.046,1.91-3.145-.667-7.262c-2.74-4.359-4.33-13.644-4.33-13.651a31.756,31.756,0,0,1-.362-3.933,25.742,25.742,0,0,1,.525-3.862,2.222,2.222,0,0,0-1.6-2.84,12.609,12.609,0,0,0-2.69-1.029,4.259,4.259,0,0,0-2.84.227,20.788,20.788,0,0,1-1.8,1.051,2.527,2.527,0,0,1-2.591-.568,2.13,2.13,0,0,1-.61-2.428Z",
    transform: "translate(-56.821 -149.495)",
    fill: "#1999cf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_313",
    "data-name": "Path 313",
    d: "M125.91,326.839a.878.878,0,0,0-.823.39c-.149.17-1.136,2.35-1.931,3.486s-2.84,3.273-3.166,5.154c.994,3.706,4.33,6.389,4.707,9.86s.284,7.489,5.424,11.926,10.584,5.09,12.593,4.046,1.91-3.145-.667-7.262c-2.74-4.359-4.33-13.644-4.33-13.651a31.756,31.756,0,0,1-.362-3.933,25.742,25.742,0,0,1,.525-3.862,2.222,2.222,0,0,0-1.6-2.84,12.609,12.609,0,0,0-2.69-1.029,4.259,4.259,0,0,0-2.84.227,20.788,20.788,0,0,1-1.8,1.051,2.527,2.527,0,0,1-2.591-.568,2.13,2.13,0,0,1-.61-2.428Z",
    transform: "translate(-56.821 -149.495)",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_314",
    "data-name": "Path 314",
    d: "M130.08,363.728a8.468,8.468,0,0,1,7.858-3.862c5.636.241,7.475,3.187,8.263,4.912.944,2.052,1.867,5.729-.5,6.687-2.556,1.029-5.452.561-9.938-1.91S130.08,363.728,130.08,363.728Z",
    transform: "translate(-59.748 -159.075)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_315",
    "data-name": "Path 315",
    d: "M132.35,340.812a.568.568,0,0,0,.511,0c.887-.412,5.537-1.193,8.121,1.42.362-.263.305-.774-.106-1.512-3.067-2.13-7.461-1.42-8.519-.9a.532.532,0,0,0-.248.71A.589.589,0,0,0,132.35,340.812Z",
    transform: "translate(-60.322 -153.104)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_316",
    "data-name": "Path 316",
    d: "M141.7,346.98a1.711,1.711,0,0,0-.263-1.562,10.531,10.531,0,0,0-8.142-.646.532.532,0,0,0-.248.71.554.554,0,0,0,.256.256.561.561,0,0,0,.511,0C134.681,345.39,139.083,344.652,141.7,346.98Z",
    transform: "translate(-60.594 -154.545)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_317",
    "data-name": "Path 317",
    d: "M144.26,357.606a3.23,3.23,0,0,0-.639-2.066c-3.053-2.009-7.347-1.306-8.405-.816a.525.525,0,0,0-.248.71.582.582,0,0,0,.767.27C136.671,355.277,141.79,354.433,144.26,357.606Z",
    transform: "translate(-61.15 -157.432)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_318",
    "data-name": "Path 318",
    d: "M134.24,350.72a.6.6,0,0,0,.518,0c.88-.4,5.431-1.164,8.029,1.327a1.973,1.973,0,0,0-.4-1.69,10.573,10.573,0,0,0-8.142-.653.532.532,0,0,0-.27.767A.618.618,0,0,0,134.24,350.72Z",
    transform: "translate(-60.856 -155.978)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_319",
    "data-name": "Path 319",
    d: "M151.527,339.32s1.753,13.992,4.1,19.486,3.549,8.157,6.936,12.38c.71.916,2.421,2.641,3.024,3.379a1.42,1.42,0,0,1-.234,2.13c-1.626,1.42-8.3,1.533-11.919-1.42s-6.786-9.037-8.923-11.358c-.8-.88-1.555-1.775-2.265-2.719s-.454-1.746-.483-2.74c0-.483.106-1.789.106-1.789-.412-2.357-1.654-6.091-2.293-8.4Z",
    transform: "translate(-62.504 -153.117)",
    fill: "#ffa8a7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_320",
    "data-name": "Path 320",
    d: "M140.367,378.49a5.1,5.1,0,0,0,.1,1.7c.341.923,3.635,3.024,4.891,3.769a7.809,7.809,0,0,1,3.649,4.508,13.519,13.519,0,0,0,6.439,6.758,21.566,21.566,0,0,0,12.586,2.265c5.381-.561,6.048-3.656,6.048-3.656s.5-2.925-.788-3.486S140.367,378.49,140.367,378.49Z",
    transform: "translate(-62.724 -164.481)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_321",
    "data-name": "Path 321",
    d: "M141.881,362.112c-.149.057-.426.121-.6.71-.071.227,0,2.733-.27,4.167s-1.228,4.359-.71,6.29c2.6,3.06,6.95,4.11,8.859,7.227s3.613,6.964,10.457,8.859,12.3.092,13.722-1.789.4-3.833-3.876-6.574c-4.536-2.911-10.187-10.982-10.194-10.989a32.519,32.519,0,0,1-2.094-3.549,27.189,27.189,0,0,1-1.235-3.883,2.988,2.988,0,0,0-.958-1.59,3.1,3.1,0,0,0-1.817-.376,13.354,13.354,0,0,0-3.01.227,4.522,4.522,0,0,0-2.57,1.477,21.144,21.144,0,0,1-1.235,1.8,2.627,2.627,0,0,1-2.7.618,2.264,2.264,0,0,1-1.661-2.016Z",
    transform: "translate(-62.669 -159.29)",
    fill: "#1999cf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_322",
    "data-name": "Path 322",
    d: "M141.881,362.112c-.149.057-.426.121-.6.71-.071.227,0,2.733-.27,4.167s-1.228,4.359-.71,6.29c2.6,3.06,6.95,4.11,8.859,7.227s3.613,6.964,10.457,8.859,12.3.092,13.722-1.789.4-3.833-3.876-6.574c-4.536-2.911-10.187-10.982-10.194-10.989a32.519,32.519,0,0,1-2.094-3.549,27.189,27.189,0,0,1-1.235-3.883,2.988,2.988,0,0,0-.958-1.59,3.1,3.1,0,0,0-1.817-.376,13.354,13.354,0,0,0-3.01.227,4.522,4.522,0,0,0-2.57,1.477,21.144,21.144,0,0,1-1.235,1.8,2.627,2.627,0,0,1-2.7.618,2.264,2.264,0,0,1-1.661-2.016Z",
    transform: "translate(-62.669 -159.29)",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_323",
    "data-name": "Path 323",
    d: "M161.43,394.982a8.866,8.866,0,0,1,5.679-7.163c5.409-2.293,8.519-.319,10.016.958,1.81,1.519,4.323,4.593,2.513,6.552-1.966,2.13-4.912,2.974-10.265,2.634S161.43,394.982,161.43,394.982Z",
    transform: "translate(-68.843 -166.881)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_324",
    "data-name": "Path 324",
    d: "M152.762,373.06a.6.6,0,0,0,.49-.213c.66-.781,4.707-3.6,8.313-2.3.22-.4-.057-.873-.781-1.377-3.84-.639-7.681,2-8.476,2.953a.561.561,0,0,0,.1.809.6.6,0,0,0,.355.128Z",
    transform: "translate(-66.159 -161.748)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_325",
    "data-name": "Path 325",
    d: "M164.4,374.712a1.817,1.817,0,0,0-.944-1.356,11.1,11.1,0,0,0-8,3.024.561.561,0,0,0,.1.809.653.653,0,0,0,.355.128.6.6,0,0,0,.49-.213C157.04,376.345,160.881,373.675,164.4,374.712Z",
    transform: "translate(-67.073 -162.981)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_326",
    "data-name": "Path 326",
    d: "M171.55,383.586a3.4,3.4,0,0,0-1.533-1.675c-3.784-.532-7.539,2.052-8.32,2.982a.568.568,0,0,0,.1.816.632.632,0,0,0,.348.128.61.61,0,0,0,.5-.213C163.337,384.793,167.809,381.7,171.55,383.586Z",
    transform: "translate(-68.883 -165.452)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_327",
    "data-name": "Path 327",
    d: "M159.031,381.575a.6.6,0,0,0,.49-.213c.653-.774,4.614-3.549,8.192-2.336a2.13,2.13,0,0,0-1.136-1.42,11.112,11.112,0,0,0-8,3.024.568.568,0,0,0,.1.816.632.632,0,0,0,.355.128Z",
    transform: "translate(-67.978 -164.215)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_328",
    "data-name": "Path 328",
    d: "M114.982,226.07c5.53,4.4,24.938,16.647,32.7,24.427,2.243,2.243,2.9,5.111,2.08,11.28-1.107,8.362-8.831,36.708-8.831,36.708-.973,1.576-2.449-1.548-2.449-1.548L108.6,255.765Z",
    transform: "translate(-53.517 -120.262)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_329",
    "data-name": "Path 329",
    d: "M140.825,293.536c-7.042-6.389-29.105-44.4-29.105-44.4l.994-.17c5.367-2.47,7.056-9.072,7.056-9.072.71,2.982-1.306,7.2-3.464,8.76,1.789,1.675,11.174,10.3,18.216,16.327a10.426,10.426,0,0,1,4.053,6.673C139.775,279.594,141.06,291.946,140.825,293.536Z",
    transform: "translate(-54.422 -124.271)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_330",
    "data-name": "Path 330",
    d: "M101.68,226.07h0l-38.93,7.149c.341,7.731,0,12.153,1.611,15.71,1.832,4.046,4.515,8.164,14.844,13.765,9.938,5.4,22.127,11.025,24.562,12.3,1.831.965,2.577,4.735,3.23,9.6.71,5.118.611,9.094,5.211,19.948,4.508,10.648,5.424,12.927,5.424,12.927s7.582,1.093,12.778-3.152c0,0-5.48-36.055-6.694-42.558-.71-3.628-.625-5.523-4.934-9.654-3.7-3.549-20.289-17.158-20.289-17.158S105.67,236.094,101.68,226.07Z",
    transform: "translate(-40.215 -120.262)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-17-3",
    "data-name": "freepik--character--inject-17",
    transform: "translate(11.725 51.78)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_331",
    "data-name": "Path 331",
    d: "M107.79,150.8c3.486-.412,8.242-.263,11.039,2.612,3.322,3.422,4.337,5.679,7.915,16.271,2.364,6.985,6.552,22.581,4.082,25.322s-9.229,2.286-9.229,2.286Z",
    transform: "translate(-65.006 -150.155)",
    fill: "#ffa8a7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_332",
    "data-name": "Path 332",
    d: "M105.28,150.535c3.784-.894,10.648-1.42,14.489,3.769s9.64,24.789,9.64,24.789A22.056,22.056,0,0,1,117.54,181.3C110.427,180.755,105.28,150.535,105.28,150.535Z",
    transform: "translate(-64.278 -149.961)",
    fill: "#1999cf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_333",
    "data-name": "Path 333",
    d: "M76.6,151.45c-4.486.064-13.048,2.35-16.178,3.2-2.676,1.335-1.824,3.187-1.668,6.524.547,11.465,2.371,35.8,2.371,35.8L61.178,216c15.135,4.856,41.564,1.242,43.658-8.959,0,0-.057-21.488-1.832-37.759-1.342-11.976-6.524-18.691-10.783-18.564Z",
    transform: "translate(-50.708 -150.18)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_334",
    "data-name": "Path 334",
    d: "M64.007,190.9l.518-15.057c.852-12.068-3.592-19.075-5.31-20.1-4.621,1.15-7.425,1.519-9.363,11.947-.71,3.855-.461,8.455-.49,15.617,0,5.679.376,11.465.951,18.067.412,4.756,2.548,5.523,8.469,5.4,4.969-.1,20.281-3.045,28.807-5.31,3.45-.916,8.519-2.648,11.152-3.549,1.938-.71,9.363-2.84,8.824-5.793a2.691,2.691,0,0,0-1.576-1.839,7.1,7.1,0,0,0-2.456-.511,39.107,39.107,0,0,0-11.025.71c-2.719.575-5.3,1.257-8.05,1.675s-8.583-2.612-11.223-2.321C68.266,190.392,64.007,190.9,64.007,190.9Z",
    transform: "translate(-48.05 -151.64)",
    fill: "#ffa8a7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_335",
    "data-name": "Path 335",
    d: "M60.242,155.13c-4.373.774-8.206,2.13-9.761,5.09s-1.846,4.849-2.378,12.941c-.745,11.408-.561,16.76-.561,16.76s9.229,3,16.448-1.186l.611-15.163S65.339,161.427,60.242,155.13Z",
    transform: "translate(-47.521 -151.46)",
    fill: "#1999cf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_336",
    "data-name": "Path 336",
    d: "M60.11,211.37s.057-4.259,7.007-6.595c0,0,4.259-.511,9.229-1.065,2.655-.291,8.575,2.754,11.223,2.357s5.331-1.1,8.05-1.675a39.107,39.107,0,0,1,11.025-.71,7.1,7.1,0,0,1,2.456.511,2.69,2.69,0,0,1,1.576,1.839c.54,2.946-6.886,5.118-8.824,5.793-1.42.49-3.471,1.2-5.622,1.9-8.142-2.179-25.989-8.263-29.013-7.475C63.809,207.1,60.983,209.113,60.11,211.37Z",
    transform: "translate(-51.174 -165.512)",
    fill: "#f28f8f",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_337",
    "data-name": "Path 337",
    d: "M73.187,202.184c6.6.71,29.254,8.093,39.434,7.752,3.1-1.044,3.386-2.641,4.174-6.921s-6.453-8.689-9.491-8.895c-30.064,2.13-37.255,6.907-37.255,6.907L70,202.035S71.278,202.042,73.187,202.184Z",
    transform: "translate(-54.043 -162.772)",
    fill: "#ffa8a7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_338",
    "data-name": "Path 338",
    d: "M70.051,203.67l-.071,1.008,1.335.043L71.1,203.23Z",
    transform: "translate(-54.037 -165.415)",
    fill: "#f28f8f",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_339",
    "data-name": "Path 339",
    d: "M125.3,194.1c3.549.575,6.907,4.337,6.907,4.337a9.37,9.37,0,0,0-3.294-4.621A29.236,29.236,0,0,1,125.3,194.1Z",
    transform: "translate(-70.086 -162.685)",
    fill: "#f28f8f",
    opacity: 0.8
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_340",
    "data-name": "Path 340",
    d: "M98.6,107.342a9.548,9.548,0,1,0,3.385-6.482,9.555,9.555,0,0,0-3.385,6.482Z",
    transform: "translate(-50.606 -83.291)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_341",
    "data-name": "Path 341",
    d: "M76.61,121.08s1.093,9.718,1.739,11.358a4.167,4.167,0,0,0,2.215,2.229l.469-6.723Z",
    transform: "translate(-44.236 -89.802)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_342",
    "data-name": "Path 342",
    d: "M78.47,101.984a3.173,3.173,0,0,0-3.01,1.193c-1.42,1.9-.965,6.943.568,12.366l3.635.767Z",
    transform: "translate(-43.654 -84.251)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_343",
    "data-name": "Path 343",
    d: "M76.43,102.245l-4.43-.8A2.13,2.13,0,0,1,74.485,99.5a2.513,2.513,0,0,1,1.945,2.747Z",
    transform: "translate(-42.899 -83.532)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_344",
    "data-name": "Path 344",
    d: "M76.676,99.986,74,96.174a2.13,2.13,0,0,1,3.138.5A2.463,2.463,0,0,1,76.676,99.986Z",
    transform: "translate(-43.479 -82.438)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_345",
    "data-name": "Path 345",
    d: "M79.9,114.809c-.781.4-1.7-1.171-2.52-2.243s-3.322-2.257-5.09.852a5.317,5.317,0,0,0,2.442,7.425c2.47.994,3.549-.177,3.549-.177l-.454,15.617c5.679,6.048,18.642,6.964,14.113-.419l.177-4.068s2.769.4,5.289.561c2.13.128,4.55-1.15,5.821-4.33a46.578,46.578,0,0,0,2.84-11.99,48.031,48.031,0,0,0,.376-7.461c-.618-10.648-13.317-14.531-20.693-10.591S79.9,114.809,79.9,114.809Z",
    transform: "translate(-42.787 -82.665)",
    fill: "#ffa8a7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_346",
    "data-name": "Path 346",
    d: "M98.457,104.4a24.087,24.087,0,0,1-7.418-2.932.98.98,0,0,0-.71-.206.958.958,0,0,0-.54.6,24.385,24.385,0,0,1-1.682,3.464,5.338,5.338,0,0,1-2.932,2.371,2.236,2.236,0,0,0-1.228.525,2.13,2.13,0,0,0-.454,1.221,9.939,9.939,0,0,0,.128,1.711c.078.781.213,2.13-.291,2.79a1.235,1.235,0,0,1-1.86.156,7.46,7.46,0,0,1-1.285-1.867,11.451,11.451,0,0,0-1.37-1.9c-.5-.518-.192-1.548-.248-2.243-.114-1.42-.114-2.79-.092-4.188,0-1.178-.582-3.869-.71-5.04-.177-1.69,0-1.079.653-2.229,1.619-5.452,7.873-7.17,12.679-6.446a50.245,50.245,0,0,0,6.446.6,47.116,47.116,0,0,0,8.128-.39,2.13,2.13,0,0,1,1.115.05,1.42,1.42,0,0,1,.667,1.59,4.2,4.2,0,0,1-.916,1.611,8.7,8.7,0,0,1,2.6-.6,3.031,3.031,0,0,1,2.421.923,3.649,3.649,0,0,1,.525,3.1,9.86,9.86,0,0,1-6.943,7.234,14.2,14.2,0,0,1-6.68.1Z",
    transform: "translate(-44.552 -80.794)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_347",
    "data-name": "Path 347",
    d: "M95.705,143.508s-6.5-1.675-8.689-3.159a7.766,7.766,0,0,1-2.9-3.549,11.131,11.131,0,0,0,1.462,4.046c1.491,2.4,10.052,4.359,10.052,4.359Z",
    transform: "translate(-46.415 -94.363)",
    fill: "#f28f8f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_348",
    "data-name": "Path 348",
    d: "M84.029,92.128c-3.741,2.243-8.128,6.63-8.327,16.626a5.267,5.267,0,0,0-2.648,4.969c.114,3.131,2.414,5.757,5.154,5.871s4.863-2.328,4.756-5.459c-.085-2.343-1.888-5.047-3.84-5.4a19.737,19.737,0,0,1,2.13-9.9c3.493-7.369,10.521-7.809,16.959-8.086C96.019,89.643,89.1,89.1,84.029,92.128Z",
    transform: "translate(-43.2 -80.748)",
    fill: "#1999cf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_349",
    "data-name": "Path 349",
    d: "M84.029,92.128c-3.741,2.243-8.128,6.63-8.327,16.626a5.267,5.267,0,0,0-2.648,4.969c.114,3.131,2.414,5.757,5.154,5.871s4.863-2.328,4.756-5.459c-.085-2.343-1.888-5.047-3.84-5.4a19.737,19.737,0,0,1,2.13-9.9c3.493-7.369,10.521-7.809,16.959-8.086C96.019,89.643,89.1,89.1,84.029,92.128Z",
    transform: "translate(-43.2 -80.748)",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_350",
    "data-name": "Path 350",
    d: "M82.807,121.418c-.121-3.464-2.676-6.389-5.679-6.51a4.785,4.785,0,0,0-1.363.149c-.369.092-1.519.518-1.746.6a5.768,5.768,0,0,0-3.549,5.793c.121,3.471,2.676,6.389,5.679,6.51a4.657,4.657,0,0,0,1.654-.206l1.6-.568A5.748,5.748,0,0,0,82.807,121.418Z",
    transform: "translate(-42.453 -88.011)",
    fill: "#1999cf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_351",
    "data-name": "Path 351",
    d: "M82.807,121.418c-.121-3.464-2.676-6.389-5.679-6.51a4.785,4.785,0,0,0-1.363.149c-.369.092-1.519.518-1.746.6a5.768,5.768,0,0,0-3.549,5.793c.121,3.471,2.676,6.389,5.679,6.51a4.657,4.657,0,0,0,1.654-.206l1.6-.568A5.748,5.748,0,0,0,82.807,121.418Z",
    transform: "translate(-42.453 -88.011)",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_352",
    "data-name": "Path 352",
    d: "M81.432,122.108c-.121-3.471-2.669-6.389-5.679-6.51s-5.4,2.584-5.274,6.048,2.676,6.389,5.679,6.51S81.552,125.572,81.432,122.108Z",
    transform: "translate(-42.456 -88.211)",
    fill: "#1999cf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_353",
    "data-name": "Path 353",
    d: "M81.432,122.108c-.121-3.471-2.669-6.389-5.679-6.51s-5.4,2.584-5.274,6.048,2.676,6.389,5.679,6.51S81.552,125.572,81.432,122.108Z",
    transform: "translate(-42.456 -88.211)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_354",
    "data-name": "Path 354",
    d: "M79.7,123.343a3.067,3.067,0,0,0-2.719-3.074,2.558,2.558,0,0,0-2.492,2.84,3.067,3.067,0,0,0,2.7,3.074A2.536,2.536,0,0,0,79.7,123.343Z",
    transform: "translate(-43.62 -89.567)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_355",
    "data-name": "Path 355",
    d: "M100.457,122.649a2.229,2.229,0,0,1-4.337-.2A3.273,3.273,0,0,0,100.457,122.649Z",
    transform: "translate(-49.896 -90.2)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_356",
    "data-name": "Path 356",
    d: "M116.013,123.7a2.236,2.236,0,0,1-4.323-.483,3.287,3.287,0,0,0,2.066,1.065,3.329,3.329,0,0,0,2.257-.582Z",
    transform: "translate(-54.413 -90.423)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_357",
    "data-name": "Path 357",
    d: "M98.5,115.174l-3.145,1.164a1.753,1.753,0,0,1,1.022-2.208,1.647,1.647,0,0,1,2.123,1.044Z",
    transform: "translate(-49.645 -87.758)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_358",
    "data-name": "Path 358",
    d: "M100.134,134.81l3.464,1.562a1.867,1.867,0,0,1-2.485,1.022,1.988,1.988,0,0,1-.98-2.584Z",
    transform: "translate(-51.013 -93.786)",
    fill: "#b16668"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_359",
    "data-name": "Path 359",
    d: "M117.1,117.342l-3.1-1.32a1.626,1.626,0,0,1,2.13-.93,1.768,1.768,0,0,1,.965,2.25Z",
    transform: "translate(-55.083 -88.031)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_360",
    "data-name": "Path 360",
    d: "M106.251,121.66l-.071,8.256,4.394-1.193Z",
    transform: "translate(-52.815 -89.971)",
    fill: "#f28f8f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_361",
    "data-name": "Path 361",
    d: "M118.569,132.32a16.327,16.327,0,0,1,2.96,2.428,3.06,3.06,0,0,1,0,4.259l-1.214-.582s1.044-1.335.476-2.336a9.746,9.746,0,0,0-2.591-2.25Z",
    transform: "translate(-56.302 -93.063)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_362",
    "data-name": "Path 362",
    d: "M121.116,140.326c-.909-.774-1.569-.248-2.754,1.32s-.809,2.194,0,2.769,1.64.163,2.556-1.157C121.954,141.781,122.1,141.156,121.116,140.326Z",
    transform: "translate(-56.13 -95.284)",
    fill: "#1999cf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_363",
    "data-name": "Path 363",
    d: "M121.116,140.326c-.909-.774-1.569-.248-2.754,1.32s-.809,2.194,0,2.769,1.64.163,2.556-1.157C121.954,141.781,122.1,141.156,121.116,140.326Z",
    transform: "translate(-56.13 -95.284)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_364",
    "data-name": "Path 364",
    d: "M33.515,95.051A4.181,4.181,0,0,1,33,93.7a1.278,1.278,0,0,1,0-.433l4.259-12.217-5.047.873c-.54.1-.894-.319-1.058-1.256l-.085-.49c-.163-.93,0-1.42.568-1.54l9.229-1.619c.149,0,.369.22.646.71a4.7,4.7,0,0,1,.525,1.349,1.96,1.96,0,0,1,0,.469L37.774,91.693l5.537-.965a.71.71,0,0,1,.71.213,2.13,2.13,0,0,1,.383,1.044l.085.483c.163.937,0,1.42-.568,1.548l-9.768,1.7C34.019,95.775,33.791,95.541,33.515,95.051Z",
    transform: "translate(-31.005 -77.02)",
    fill: "#1999cf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_365",
    "data-name": "Path 365",
    d: "M55.317,103.04a3.549,3.549,0,0,1-.355-1.136.987.987,0,0,1,0-.355L59.093,91.8l-4.146.44c-.447.05-.71-.319-.8-1.086l-.043-.4c-.078-.774.106-1.186.554-1.228L62.33,88.7c.121,0,.284.192.49.625a3.755,3.755,0,0,1,.348,1.136,1.419,1.419,0,0,1,0,.383l-4.11,9.7,4.579-.49a.54.54,0,0,1,.54.213,1.817,1.817,0,0,1,.256.873l.043.4c.085.767-.1,1.178-.547,1.228l-8.086.866C55.686,103.657,55.516,103.459,55.317,103.04Z",
    transform: "translate(-37.701 -80.409)",
    fill: "#1999cf"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_384",
    "data-name": "Group 384",
    transform: "translate(16.384 8.291)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_366",
    "data-name": "Path 366",
    d: "M55.317,103.04a3.549,3.549,0,0,1-.355-1.136.987.987,0,0,1,0-.355L59.093,91.8l-4.146.44c-.447.05-.71-.319-.8-1.086l-.043-.4c-.078-.774.106-1.186.554-1.228L62.33,88.7c.121,0,.284.192.49.625a3.755,3.755,0,0,1,.348,1.136,1.419,1.419,0,0,1,0,.383l-4.11,9.7,4.579-.49a.54.54,0,0,1,.54.213,1.817,1.817,0,0,1,.256.873l.043.4c.085.767-.1,1.178-.547,1.228l-8.086.866C55.686,103.657,55.516,103.459,55.317,103.04Z",
    transform: "translate(-54.085 -88.7)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-17",
    transform: "translate(290.484 207.848)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Pot--inject-17",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--pot--inject-17-2",
    "data-name": "freepik--pot--inject-17",
    transform: "translate(3.807 30.869)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_380",
    "data-name": "Path 380",
    d: "M417.159,364.058c-6.453-6.652-10.244-33.734-3.947-39.008h32c6.29,5.274,2.506,32.342-3.94,39l-.177.185-.22.22c-.185.177-.376.355-.582.525l-.156.121c-.156.128-.312.256-.49.376s-.547.376-.831.54c-5.3,3.1-13.907,3.1-19.21,0h0a10.025,10.025,0,0,1-.845-.547c-.156-.114-.305-.227-.447-.348l-.192-.149c-.2-.163-.39-.334-.561-.5l-.263-.256C417.258,364.136,417.2,364.058,417.159,364.058Z",
    transform: "translate(-409.987 -319.688)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_381",
    "data-name": "Path 381",
    d: "M442.65,320.693c7.3,4.259,7.3,11.174,0,15.44s-19.167,4.259-26.443,0-7.3-11.174,0-15.44S435.352,316.434,442.65,320.693Z",
    transform: "translate(-410.206 -317.496)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_382",
    "data-name": "Path 382",
    d: "M441.17,323.937c5.36,3.131,5.36,8.206,0,11.358s-14.063,3.131-19.422,0-5.36-8.206,0-11.358S435.8,320.807,441.17,323.937Z",
    transform: "translate(-412.233 -318.681)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_383",
    "data-name": "Path 383",
    d: "M422.079,331.52c5.36-3.131,14.056-3.131,19.422,0a8.944,8.944,0,0,1,3.209,2.982,8.874,8.874,0,0,1-3.209,2.974c-5.367,3.131-14.063,3.131-19.422,0a8.874,8.874,0,0,1-3.209-2.974A8.944,8.944,0,0,1,422.079,331.52Z",
    transform: "translate(-412.564 -320.884)",
    fill: "#f5f5f5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-17"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_384",
    "data-name": "Path 384",
    d: "M433,301.852a8.754,8.754,0,0,1-.816-2.336,5.523,5.523,0,0,1,1.7-5.388c.625-.476,1.42-.831,1.711-1.569a2.491,2.491,0,0,0,0-1.292c-.291-1.661-.852-3.379-.39-5a5.587,5.587,0,0,1,3.1-3.322,16.732,16.732,0,0,1,4.522-1.186,7.248,7.248,0,0,0,2.392-.71c.894-.5,1.171-1.384,1.732-2.13a15.214,15.214,0,0,1,2.194-2.343,8.593,8.593,0,0,1,5.927-2.556c4.707.213,4.572,4.259,3.216,7.333s-1.718,4.068,1.221,7.269,2.946,7.141-.561,9.349-5.793,2.5-4.4,6.751c1.242,3.8,2.009,7.035-1.5,11.1a11.438,11.438,0,0,1-9.229,4.33,15.468,15.468,0,0,1-4.529-1.058c-1.072-.532-.355-1.363-.71-2.414l-2.328-6.786a50.064,50.064,0,0,0-1.846-5.353C433.958,303.591,433.44,302.747,433,301.852Z",
    transform: "translate(-412.587 -274.012)",
    fill: "#1999cf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_385",
    "data-name": "Path 385",
    d: "M442.2,321.857a.348.348,0,0,0,.234-.334c-.2-23.249,12.615-37.134,12.742-37.269a.355.355,0,0,0,0-.5.341.341,0,0,0-.49,0c-.135.142-13.14,14.2-12.941,37.759a.362.362,0,0,0,.355.348Z",
    transform: "translate(-415.394 -276.809)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_386",
    "data-name": "Path 386",
    d: "M447.467,304.822l.064-.035c4.174-2.627,11.614-4.579,11.692-4.6a.355.355,0,0,0,.248-.426.348.348,0,0,0-.426-.256c-.312.078-7.617,2.009-11.876,4.685a.355.355,0,0,0,.3.632Z",
    transform: "translate(-416.924 -281.405)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_387",
    "data-name": "Path 387",
    d: "M447.715,299.637h0a.355.355,0,0,0,.185-.461,26.444,26.444,0,0,0-3.848-6.467.334.334,0,0,0-.483-.043.355.355,0,0,0-.043.5,26.815,26.815,0,0,1,3.734,6.283A.355.355,0,0,0,447.715,299.637Z",
    transform: "translate(-415.887 -279.399)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_388",
    "data-name": "Path 388",
    d: "M428.168,327.007a19.557,19.557,0,0,1-10.208.376c-5.857-1.264-9.441-6.737-9.441-6.737s6.332-2.534,10.031-2.783a32.655,32.655,0,0,0-11.1.234s-3.393-1.257-2.747-6.985c0,0,3.187-2.35,10.535-1.42a23.511,23.511,0,0,0-10.137-3.4c-.5,0,.185-7.454.8-10.776s1.839-2.84,4.479-2.527,10.442,2.066,11.429,3.982,0,6.794,0,6.794a11.2,11.2,0,0,0,2.13-6.389,17.315,17.315,0,0,1,4.508,2.463,10.33,10.33,0,0,1,2.8,3.514c-.362,2.619-1.6,6.609-3.322,8.838a11.9,11.9,0,0,0,4.778-7.134,16.114,16.114,0,0,1,3.081,9.1C435.807,320.015,433.208,324.359,428.168,327.007Z",
    transform: "translate(-404.625 -279.453)",
    fill: "#1999cf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_389",
    "data-name": "Path 389",
    d: "M428.168,327.007a19.557,19.557,0,0,1-10.208.376c-5.857-1.264-9.441-6.737-9.441-6.737s6.332-2.534,10.031-2.783a32.655,32.655,0,0,0-11.1.234s-3.393-1.257-2.747-6.985c0,0,3.187-2.35,10.535-1.42a23.511,23.511,0,0,0-10.137-3.4c-.5,0,.185-7.454.8-10.776s1.839-2.84,4.479-2.527,10.442,2.066,11.429,3.982,0,6.794,0,6.794a11.2,11.2,0,0,0,2.13-6.389,17.315,17.315,0,0,1,4.508,2.463,10.33,10.33,0,0,1,2.8,3.514c-.362,2.619-1.6,6.609-3.322,8.838a11.9,11.9,0,0,0,4.778-7.134,16.114,16.114,0,0,1,3.081,9.1C435.807,320.015,433.208,324.359,428.168,327.007Z",
    transform: "translate(-404.625 -279.453)",
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_390",
    "data-name": "Path 390",
    d: "M431.052,326.867a.348.348,0,0,1-.213-.284c-.887-11.1-13.3-28.431-18.791-31.945a.341.341,0,0,1-.1-.461.334.334,0,0,1,.454-.107c5.58,3.549,18.2,21.155,19.1,32.428a.327.327,0,0,1-.447.341Z",
    transform: "translate(-406.735 -279.817)",
    fill: "#fff"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg500);
export default __webpack_public_path__ + "static/media/500.2e3c90c20490ec83e9541170bd68998b.svg";
export { ForwardRef as ReactComponent };